export const BooznoLogo = () => (
  <svg
    width="183"
    height="34"
    viewBox="0 0 183 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.29545 0C1.92314 0 0 1.92314 0 4.29546V20.6686V34H8.59091V33.9998H13.759C13.8729 33.9998 13.9859 33.9953 14.0976 33.9865C21.2761 33.6777 27 27.8332 27 20.6686C27 13.3062 20.9558 7.33789 13.5 7.33789C11.7681 7.33789 10.1124 7.65992 8.59091 8.24666V4.29546C8.59091 1.92314 6.66777 0 4.29545 0ZM8.59091 20.8058V20.7312C8.61122 18.2013 10.6944 16.1566 13.2612 16.1566C15.8406 16.1566 17.9317 18.2215 17.9317 20.7685C17.9317 23.3156 15.8406 25.3804 13.2612 25.3804C10.6944 25.3804 8.61122 23.3357 8.59091 20.8058Z"
      fill="#7D63EC"
    />
    <g clipPath="url(#clip0_6_600)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.29545 0C1.92314 0 0 1.92314 0 4.29546V20.6686V34H8.59091V33.0905C3.56233 31.1513 0 26.3208 0 20.6686C0 15.0164 3.56233 10.1858 8.59091 8.24666V4.29546C8.59091 1.92314 6.66777 0 4.29545 0Z"
        fill="#5642C3"
      />
    </g>
    <g clipPath="url(#clip1_6_600)">
      <path
        d="M58.2041 22.8531C58.2041 20.95 57.5232 19.3188 56.1159 17.9141C54.754 16.5547 53.0743 15.8297 51.1676 15.8297C49.261 15.8297 47.5813 16.5094 46.2194 17.9141C44.8575 19.2734 44.1765 20.9047 44.1765 22.8531C44.1765 24.8016 44.8575 26.4328 46.2194 27.7922C47.5813 29.1516 49.261 29.8312 51.1676 29.8312C53.0743 29.8312 54.7086 29.1516 56.1159 27.7922C57.5232 26.3875 58.2041 24.7563 58.2041 22.8531ZM62.426 22.8531C62.426 25.9344 61.3365 28.5625 59.1121 30.7375C56.933 32.9125 54.3 34 51.213 34C48.126 34 45.493 32.9125 43.2686 30.7375C41.0895 28.5625 40 25.9344 40 22.8531V5H44.2219V14.6063C46.3102 12.6125 48.7616 11.6156 51.5762 11.6156C54.5724 11.6156 57.16 12.7031 59.2483 14.9234C61.3819 17.1891 62.426 19.8172 62.426 22.8531Z"
        fill="#7D63EC"
      />
      <path
        d="M83.4898 22.8533C83.4898 20.9502 82.8088 19.3189 81.4015 17.9143C80.0396 16.5549 78.3599 15.8299 76.4533 15.8299C74.5466 15.8299 72.8669 16.5096 71.505 17.9143C70.1431 19.2736 69.4621 20.9049 69.4621 22.8533C69.4621 24.8018 70.1431 26.433 71.505 27.7924C72.8669 29.1518 74.5466 29.8314 76.4533 29.8314C78.3599 29.8314 80.0396 29.1518 81.4015 27.7924C82.7634 26.3877 83.4898 24.7564 83.4898 22.8533ZM87.6663 22.8533C87.6663 25.9346 86.5767 28.5627 84.3523 30.7377C82.1733 32.9127 79.5402 34.0002 76.4533 34.0002C73.3663 34.0002 70.7333 32.9127 68.5088 30.7377C66.3298 28.5627 65.2402 25.9346 65.2402 22.8533C65.2402 19.7721 66.3298 17.1439 68.5088 14.9689C70.7333 12.7486 73.3663 11.6611 76.4533 11.6611C79.5402 11.6611 82.1733 12.7486 84.3977 14.9689C86.5767 17.1439 87.6663 19.7721 87.6663 22.8533Z"
        fill="#7D63EC"
      />
      <path
        d="M108.73 22.8533C108.73 20.9502 108.05 19.3189 106.642 17.9143C105.28 16.5549 103.601 15.8299 101.694 15.8299C99.7873 15.8299 98.1076 16.5096 96.7457 17.9143C95.3838 19.2736 94.7028 20.9049 94.7028 22.8533C94.7028 24.8018 95.3838 26.433 96.7457 27.7924C98.1076 29.1518 99.7419 29.8314 101.694 29.8314C103.646 29.8314 105.28 29.1518 106.642 27.7924C108.004 26.3877 108.73 24.7564 108.73 22.8533ZM112.907 22.8533C112.907 25.9346 111.817 28.5627 109.593 30.7377C107.369 32.9127 104.736 34.0002 101.649 34.0002C98.5616 34.0002 95.9286 32.9127 93.7041 30.7377C91.5251 28.5627 90.4355 25.9346 90.4355 22.8533C90.4355 19.7721 91.5251 17.1439 93.7041 14.9689C95.9286 12.7486 98.5616 11.6611 101.649 11.6611C104.736 11.6611 107.369 12.7486 109.593 14.9689C111.817 17.1439 112.907 19.7721 112.907 22.8533Z"
        fill="#7D63EC"
      />
      <path
        d="M123.167 29.4691H134.289V33.6379H115.495L126.89 16.1926H115.767V11.9785H134.607L123.167 29.4691Z"
        fill="#7D63EC"
      />
      <path
        d="M152.675 33.6371V21.0855C152.675 19.6809 152.176 18.4121 151.131 17.4152C150.087 16.373 148.862 15.8746 147.454 15.8746C146.047 15.8746 144.776 16.373 143.777 17.4152C142.778 18.4574 142.234 19.6809 142.234 21.0855V33.6371H138.012V21.0855C138.012 18.5934 138.965 16.373 140.872 14.4699C142.778 12.5668 145.003 11.6152 147.5 11.6152C149.996 11.6152 152.176 12.5668 154.082 14.4699C155.989 16.373 156.942 18.5934 156.942 21.0855V33.6371H152.675Z"
        fill="#7D63EC"
      />
      <path
        d="M178.778 22.8533C178.778 20.9502 178.097 19.3189 176.69 17.9143C175.328 16.5549 173.648 15.8299 171.741 15.8299C169.835 15.8299 168.155 16.5096 166.793 17.9143C165.431 19.2736 164.75 20.9049 164.75 22.8533C164.75 24.8018 165.431 26.433 166.793 27.7924C168.155 29.1518 169.835 29.8314 171.741 29.8314C173.693 29.8314 175.328 29.1518 176.69 27.7924C178.097 26.3877 178.778 24.7564 178.778 22.8533ZM183 22.8533C183 25.9346 181.91 28.5627 179.686 30.7377C177.461 32.9127 174.828 34.0002 171.741 34.0002C168.654 34.0002 166.021 32.9127 163.797 30.7377C161.618 28.5627 160.528 25.9346 160.528 22.8533C160.528 19.7721 161.618 17.1439 163.797 14.9689C166.021 12.7486 168.654 11.6611 171.741 11.6611C174.828 11.6611 177.461 12.7486 179.686 14.9689C181.91 17.1439 183 19.7721 183 22.8533Z"
        fill="#7D63EC"
      />
    </g>
    <defs>
      <clipPath id="clip0_6_600">
        <rect width="8.59091" height="21.0733" fill="white" />
      </clipPath>
      <clipPath id="clip1_6_600">
        <rect
          width="143"
          height="29"
          fill="white"
          transform="translate(40 5)"
        />
      </clipPath>
    </defs>
  </svg>
);
export const PlusIcon = () => (
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.5 3.3335V12.6668"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.83301 8H13.1663"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const DashboardIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.1666 8.33332H15.8333C17.5 8.33332 18.3333 7.49999 18.3333 5.83332V4.16666C18.3333 2.49999 17.5 1.66666 15.8333 1.66666H14.1666C12.5 1.66666 11.6666 2.49999 11.6666 4.16666V5.83332C11.6666 7.49999 12.5 8.33332 14.1666 8.33332Z"
      stroke="#E4E5EB"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.16669 18.3333H5.83335C7.50002 18.3333 8.33335 17.5 8.33335 15.8333V14.1667C8.33335 12.5 7.50002 11.6667 5.83335 11.6667H4.16669C2.50002 11.6667 1.66669 12.5 1.66669 14.1667V15.8333C1.66669 17.5 2.50002 18.3333 4.16669 18.3333Z"
      stroke="#E4E5EB"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.00002 8.33332C6.84097 8.33332 8.33335 6.84094 8.33335 4.99999C8.33335 3.15904 6.84097 1.66666 5.00002 1.66666C3.15907 1.66666 1.66669 3.15904 1.66669 4.99999C1.66669 6.84094 3.15907 8.33332 5.00002 8.33332Z"
      stroke="#E4E5EB"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15 18.3333C16.8409 18.3333 18.3333 16.8409 18.3333 15C18.3333 13.159 16.8409 11.6667 15 11.6667C13.159 11.6667 11.6666 13.159 11.6666 15C11.6666 16.8409 13.159 18.3333 15 18.3333Z"
      stroke="#E4E5EB"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const CalenderIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
  >
    <path
      d="M6.66669 2.06485V4.56485"
      stroke="#E4E5EB"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.3333 2.06485V4.56485"
      stroke="#E4E5EB"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.91669 7.97632H17.0834"
      stroke="#E4E5EB"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.5 7.48152V14.5649C17.5 17.0649 16.25 18.7315 13.3333 18.7315H6.66667C3.75 18.7315 2.5 17.0649 2.5 14.5649V7.48152C2.5 4.98152 3.75 3.31485 6.66667 3.31485H13.3333C16.25 3.31485 17.5 4.98152 17.5 7.48152Z"
      stroke="#E4E5EB"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.0789 11.8175H13.0864"
      stroke="#E4E5EB"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.0789 14.3175H13.0864"
      stroke="#E4E5EB"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.99626 11.8175H10.0037"
      stroke="#E4E5EB"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.99626 14.3175H10.0037"
      stroke="#E4E5EB"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.91191 11.8175H6.91939"
      stroke="#E4E5EB"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.91191 14.3175H6.91939"
      stroke="#E4E5EB"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const ReminderIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M18.3334 10C18.3334 14.6 14.6 18.3333 10 18.3333C5.40002 18.3333 1.66669 14.6 1.66669 10C1.66669 5.40001 5.40002 1.66667 10 1.66667C14.6 1.66667 18.3334 5.40001 18.3334 10Z"
      stroke="#E4E5EB"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.0916 12.6482L10.5083 11.1065C10.0583 10.8398 9.69159 10.1982 9.69159 9.67318V6.25652"
      stroke="#E4E5EB"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const GuestIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M11.4416 2.92552L12.9083 5.85885C13.1083 6.26718 13.6416 6.65885 14.0916 6.73385L16.7499 7.17552C18.4499 7.45885 18.8499 8.69218 17.6249 9.90885L15.5583 11.9755C15.2083 12.3255 15.0166 13.0005 15.1249 13.4838L15.7166 16.0422C16.1833 18.0672 15.1083 18.8505 13.3166 17.7922L10.8249 16.3172C10.3749 16.0505 9.63326 16.0505 9.17492 16.3172L6.68326 17.7922C4.89992 18.8505 3.81659 18.0588 4.28326 16.0422L4.87492 13.4838C4.98326 13.0005 4.79159 12.3255 4.44159 11.9755L2.37492 9.90885C1.15826 8.69218 1.54992 7.45885 3.24992 7.17552L5.90826 6.73385C6.34992 6.65885 6.88326 6.26718 7.08326 5.85885L8.54992 2.92552C9.34992 1.33385 10.6499 1.33385 11.4416 2.92552Z"
      stroke="#E4E5EB"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const SettingsIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61929 11.3807 7.5 10 7.5C8.61929 7.5 7.5 8.61929 7.5 10C7.5 11.3807 8.61929 12.5 10 12.5Z"
      stroke="#E4E5EB"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.66669 10.7345V9.26784C1.66669 8.40117 2.37502 7.6845 3.25002 7.6845C4.75835 7.6845 5.37502 6.61784 4.61669 5.3095C4.18335 4.5595 4.44169 3.5845 5.20002 3.15117L6.64169 2.32617C7.30002 1.9345 8.15002 2.16784 8.54169 2.82617L8.63335 2.9845C9.38335 4.29284 10.6167 4.29284 11.375 2.9845L11.4667 2.82617C11.8584 2.16784 12.7084 1.9345 13.3667 2.32617L14.8084 3.15117C15.5667 3.5845 15.825 4.5595 15.3917 5.3095C14.6334 6.61784 15.25 7.6845 16.7584 7.6845C17.625 7.6845 18.3417 8.39284 18.3417 9.26784V10.7345C18.3417 11.6012 17.6334 12.3178 16.7584 12.3178C15.25 12.3178 14.6334 13.3845 15.3917 14.6928C15.825 15.4512 15.5667 16.4178 14.8084 16.8512L13.3667 17.6762C12.7084 18.0678 11.8584 17.8345 11.4667 17.1762L11.375 17.0178C10.625 15.7095 9.39169 15.7095 8.63335 17.0178L8.54169 17.1762C8.15002 17.8345 7.30002 18.0678 6.64169 17.6762L5.20002 16.8512C4.44169 16.4178 4.18335 15.4428 4.61669 14.6928C5.37502 13.3845 4.75835 12.3178 3.25002 12.3178C2.37502 12.3178 1.66669 11.6012 1.66669 10.7345Z"
      stroke="#E4E5EB"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const ImportIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.3334 9.16666V14.1667C18.3334 17.5 17.5 18.3333 14.1667 18.3333H5.83335C2.50002 18.3333 1.66669 17.5 1.66669 14.1667V5.83333C1.66669 2.5 2.50002 1.66666 5.83335 1.66666H7.08335C8.33335 1.66666 8.60835 2.03333 9.08335 2.66666L10.3334 4.33333C10.65 4.75 10.8334 5 11.6667 5H14.1667C17.5 5 18.3334 5.83333 18.3334 9.16666Z"
      stroke="#E4E5EB"
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
    <path
      d="M6.66669 1.66666H14.1667C15.8334 1.66666 16.6667 2.5 16.6667 4.16666V5.31666"
      stroke="#E4E5EB"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const InquiryIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      d="M14 1.5C13.337 1.5 12.7011 1.76339 12.2322 2.23223C11.7634 2.70107 11.5 3.33696 11.5 4V14C11.5 14.663 11.7634 15.2989 12.2322 15.7678C12.7011 16.2366 13.337 16.5 14 16.5C14.663 16.5 15.2989 16.2366 15.7678 15.7678C16.2366 15.2989 16.5 14.663 16.5 14C16.5 13.337 16.2366 12.7011 15.7678 12.2322C15.2989 11.7634 14.663 11.5 14 11.5H4C3.33696 11.5 2.70107 11.7634 2.23223 12.2322C1.76339 12.7011 1.5 13.337 1.5 14C1.5 14.663 1.76339 15.2989 2.23223 15.7678C2.70107 16.2366 3.33696 16.5 4 16.5C4.66304 16.5 5.29893 16.2366 5.76777 15.7678C6.23661 15.2989 6.5 14.663 6.5 14V4C6.5 3.33696 6.23661 2.70107 5.76777 2.23223C5.29893 1.76339 4.66304 1.5 4 1.5C3.33696 1.5 2.70107 1.76339 2.23223 2.23223C1.76339 2.70107 1.5 3.33696 1.5 4C1.5 4.66304 1.76339 5.29893 2.23223 5.76777C2.70107 6.23661 3.33696 6.5 4 6.5H14C14.663 6.5 15.2989 6.23661 15.7678 5.76777C16.2366 5.29893 16.5 4.66304 16.5 4C16.5 3.33696 16.2366 2.70107 15.7678 2.23223C15.2989 1.76339 14.663 1.5 14 1.5Z"
      stroke="#E4E5EB"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const NotificationIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.0163 2.42188C7.25798 2.42188 5.01631 4.66354 5.01631 7.42188V9.83021C5.01631 10.3385 4.79965 11.1135 4.54131 11.5469L3.58298 13.1385C2.99131 14.1219 3.39965 15.2135 4.48298 15.5802C8.07465 16.7802 11.9496 16.7802 15.5413 15.5802C16.5496 15.2469 16.9913 14.0552 16.4413 13.1385L15.483 11.5469C15.233 11.1135 15.0163 10.3385 15.0163 9.83021V7.42188C15.0163 4.67188 12.7663 2.42188 10.0163 2.42188Z"
      stroke="#E4E5EB"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M11.5582 2.66458C11.2999 2.58958 11.0332 2.53124 10.7582 2.49791C9.95825 2.39791 9.19158 2.45624 8.47491 2.66458C8.71658 2.04791 9.31658 1.61458 10.0166 1.61458C10.7166 1.61458 11.3166 2.04791 11.5582 2.66458Z"
      stroke="#E4E5EB"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.5163 15.8854C12.5163 17.2604 11.3913 18.3854 10.0163 18.3854C9.33296 18.3854 8.69963 18.1021 8.24963 17.6521C7.79963 17.2021 7.5163 16.5687 7.5163 15.8854"
      stroke="#E4E5EB"
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
  </svg>
);
export const NotificationIconFilled = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="#FFFFFF"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.0163 2.42188C7.25798 2.42188 5.01631 4.66354 5.01631 7.42188V9.83021C5.01631 10.3385 4.79965 11.1135 4.54131 11.5469L3.58298 13.1385C2.99131 14.1219 3.39965 15.2135 4.48298 15.5802C8.07465 16.7802 11.9496 16.7802 15.5413 15.5802C16.5496 15.2469 16.9913 14.0552 16.4413 13.1385L15.483 11.5469C15.233 11.1135 15.0163 10.3385 15.0163 9.83021V7.42188C15.0163 4.67188 12.7663 2.42188 10.0163 2.42188Z"
      stroke="#FFFFFF"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M11.5582 2.66458C11.2999 2.58958 11.0332 2.53124 10.7582 2.49791C9.95825 2.39791 9.19158 2.45624 8.47491 2.66458C8.71658 2.04791 9.31658 1.61458 10.0166 1.61458C10.7166 1.61458 11.3166 2.04791 11.5582 2.66458Z"
      stroke="#FFFFFF"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.5163 15.8854C12.5163 17.2604 11.3913 18.3854 10.0163 18.3854C9.33296 18.3854 8.69963 18.1021 8.24963 17.6521C7.79963 17.2021 7.5163 16.5687 7.5163 15.8854"
      stroke="#FFFFFF"
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
  </svg>
);
export const ActiveIcon = () => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="26" height="26" rx="7" fill="#745BE3" />
    <path
      d="M15.625 11.4833L10.375 8.45581"
      stroke="#FDFDFE"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.25 15.3334V10.6668C18.2498 10.4622 18.1958 10.2612 18.0934 10.0841C17.991 9.90699 17.8438 9.7599 17.6667 9.65761L13.5833 7.32427C13.406 7.22188 13.2048 7.16797 13 7.16797C12.7952 7.16797 12.594 7.22188 12.4167 7.32427L8.33333 9.65761C8.15615 9.7599 8.00899 9.90699 7.9066 10.0841C7.80422 10.2612 7.75021 10.4622 7.75 10.6668V15.3334C7.75021 15.538 7.80422 15.739 7.9066 15.9161C8.00899 16.0932 8.15615 16.2403 8.33333 16.3426L12.4167 18.6759C12.594 18.7783 12.7952 18.8322 13 18.8322C13.2048 18.8322 13.406 18.7783 13.5833 18.6759L17.6667 16.3426C17.8438 16.2403 17.991 16.0932 18.0934 15.9161C18.1958 15.739 18.2498 15.538 18.25 15.3334Z"
      stroke="#FDFDFE"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.9082 10.0601L13.0007 13.0059L18.0932 10.0601"
      stroke="#FDFDFE"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13 18.88V13"
      stroke="#FDFDFE"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const PendingIcon = () => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="26" height="26" rx="7" fill="#E7E4FF" />
    <path
      d="M15.625 11.4833L10.375 8.45581"
      stroke="#8E88BB"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.25 15.3334V10.6668C18.2498 10.4622 18.1958 10.2612 18.0934 10.0841C17.991 9.90699 17.8438 9.7599 17.6667 9.65761L13.5833 7.32427C13.406 7.22188 13.2048 7.16797 13 7.16797C12.7952 7.16797 12.594 7.22188 12.4167 7.32427L8.33333 9.65761C8.15615 9.7599 8.00899 9.90699 7.9066 10.0841C7.80422 10.2612 7.75021 10.4622 7.75 10.6668V15.3334C7.75021 15.538 7.80422 15.739 7.9066 15.9161C8.00899 16.0932 8.15615 16.2403 8.33333 16.3426L12.4167 18.6759C12.594 18.7783 12.7952 18.8322 13 18.8322C13.2048 18.8322 13.406 18.7783 13.5833 18.6759L17.6667 16.3426C17.8438 16.2403 17.991 16.0932 18.0934 15.9161C18.1958 15.739 18.2498 15.538 18.25 15.3334Z"
      stroke="#8E88BB"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.9082 10.0601L13.0007 13.0059L18.0932 10.0601"
      stroke="#8E88BB"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13 18.88V13"
      stroke="#8E88BB"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const DoneIcon = () => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="26" height="26" rx="7" fill="#00AEAB" />
    <path
      d="M17.1864 7.73431C16.068 6.61592 14.581 6 12.9994 6C11.4178 6 9.9308 6.61592 8.81243 7.73431C7.69404 8.85272 7.07812 10.3397 7.07812 11.9213C7.07812 15.1208 10.1034 17.7821 11.7287 19.2118C11.9545 19.4104 12.1496 19.582 12.305 19.7272C12.4997 19.909 12.7496 20 12.9994 20C13.2493 20 13.4991 19.909 13.6939 19.7272C13.8492 19.582 14.0443 19.4104 14.2701 19.2118C15.8954 17.782 18.9207 15.1208 18.9207 11.9213C18.9207 10.3397 18.3048 8.85272 17.1864 7.73431ZM13.7285 18.596C13.4977 18.7991 13.2983 18.9744 13.134 19.1279C13.0585 19.1984 12.9403 19.1984 12.8648 19.1279C12.7004 18.9744 12.5011 18.799 12.2703 18.596C10.7423 17.2519 7.89817 14.75 7.89817 11.9213C7.89817 9.1085 10.1865 6.82012 12.9994 6.82012C15.8122 6.82012 18.1006 9.1085 18.1006 11.9213C18.1006 14.75 15.2564 17.2519 13.7285 18.596Z"
      fill="white"
    />
    <path
      d="M13.0001 9.08984C11.5612 9.08984 10.3906 10.2604 10.3906 11.6993C10.3906 13.1381 11.5612 14.3087 13.0001 14.3087C14.4389 14.3087 15.6095 13.1381 15.6095 11.6993C15.6095 10.2604 14.4389 9.08984 13.0001 9.08984ZM13.0001 13.4886C12.0134 13.4886 11.2107 12.6859 11.2107 11.6992C11.2107 10.7126 12.0134 9.90991 13.0001 9.90991C13.9867 9.90991 14.7894 10.7126 14.7894 11.6992C14.7894 12.6859 13.9867 13.4886 13.0001 13.4886Z"
      fill="white"
    />
  </svg>
);
export const DeleteIconRed = ({ height = "16", width = "16" }) => (
  <svg
    height={height}
    width={width}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M2 4H3.33333H14" fill="#888888" />
    <path
      d="M2 4H3.33333H14"
      stroke="#F27953"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.33398 3.99992V2.66659C5.33398 2.31296 5.47446 1.97382 5.72451 1.72378C5.97456 1.47373 6.3137 1.33325 6.66732 1.33325H9.33398C9.68761 1.33325 10.0267 1.47373 10.2768 1.72378C10.5268 1.97382 10.6673 2.31296 10.6673 2.66659V3.99992M12.6673 3.99992V13.3333C12.6673 13.6869 12.5268 14.026 12.2768 14.2761C12.0267 14.5261 11.6876 14.6666 11.334 14.6666H4.66732C4.3137 14.6666 3.97456 14.5261 3.72451 14.2761C3.47446 14.026 3.33398 13.6869 3.33398 13.3333V3.99992H12.6673Z"
      stroke="#F27953"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.66602 7.33325V11.3333"
      stroke="#F27953"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.33398 7.33325V11.3333"
      stroke="#F27953"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const ImportIconPurple = () => (
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.5 10.6867V13.3534C14.5 13.707 14.3595 14.0461 14.1095 14.2962C13.8594 14.5462 13.5203 14.6867 13.1667 14.6867H3.83333C3.47971 14.6867 3.14057 14.5462 2.89052 14.2962C2.64048 14.0461 2.5 13.707 2.5 13.3534V10.6867"
      stroke="#7D63EC"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.8337 6.02004L8.50033 2.68671L5.16699 6.02004"
      stroke="#7D63EC"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.5 2.68671V10.6867"
      stroke="#7D63EC"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const DownloadCloudIcon = () => (
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_101_586)">
      <path
        d="M5.83301 12.0201L8.49967 14.6868L11.1663 12.0201"
        stroke="#7D63EC"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.5 8.68677V14.6868"
        stroke="#7D63EC"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.4204 12.7467C15 12.3392 15.4347 11.7575 15.6613 11.0862C15.8879 10.4148 15.8947 9.68873 15.6807 9.01327C15.4667 8.33781 15.043 7.74812 14.4712 7.32976C13.8993 6.91141 13.209 6.68617 12.5004 6.68672H11.6604C11.4599 5.9053 11.0848 5.17955 10.5632 4.56411C10.0416 3.94866 9.38721 3.45956 8.64925 3.13363C7.91129 2.80769 7.10901 2.65341 6.30279 2.6824C5.49658 2.71139 4.70745 2.9229 3.99481 3.30101C3.28217 3.67911 2.66459 4.21396 2.18857 4.86528C1.71254 5.5166 1.39048 6.26742 1.24662 7.06122C1.10276 7.85503 1.14085 8.67112 1.35803 9.44807C1.57521 10.225 1.96582 10.9426 2.50044 11.5467"
        stroke="#7D63EC"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_101_586">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="translate(0.5 0.686768)"
        />
      </clipPath>
    </defs>
  </svg>
);
export const LeftArrowIcon = () => (
  <svg
    width="8"
    height="12"
    viewBox="0 0 8 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.25 10.5L1.75 6L6.25 1.5"
      stroke="#58596B"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const LeftArrowIconDark = () => (
  <svg
    width="8"
    height="12"
    viewBox="0 0 8 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.5 1L1.5 6L6.5 11"
      stroke="#4D4F50"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const MinusIconLight = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.33398 8H12.6673"
      stroke="#ABB2B3"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const PlusIconLight = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 3.33325V12.6666"
      stroke="#ABB2B3"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.33398 8H12.6673"
      stroke="#ABB2B3"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const FilterIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.66602 14V9.33337"
      stroke="#8181A5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.66602 6.66667V2"
      stroke="#8181A5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 14V8"
      stroke="#8181A5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 5.33333V2"
      stroke="#8181A5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.334 14V10.6666"
      stroke="#8181A5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.334 8V2"
      stroke="#8181A5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M0.666016 9.33337H4.66602"
      stroke="#8181A5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 5.33337H10"
      stroke="#8181A5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.334 10.6666H15.334"
      stroke="#8181A5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const SearchIcon = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.625 0.25C3.10418 0.25 0.25 3.10418 0.25 6.625C0.25 10.1458 3.10418 13 6.625 13C8.1134 13 9.48267 12.4899 10.5675 11.635L10.87 11.9306L13.2197 14.2803L13.2903 14.3427C13.5845 14.5715 14.01 14.5507 14.2803 14.2803C14.5732 13.9874 14.5732 13.5126 14.2803 13.2197L11.9245 10.8639L11.6291 10.5751C12.4875 9.48905 13 8.11687 13 6.625C13 3.10418 10.1458 0.25 6.625 0.25ZM6.625 1.75C9.31739 1.75 11.5 3.93261 11.5 6.625C11.5 9.31739 9.31739 11.5 6.625 11.5C3.93261 11.5 1.75 9.31739 1.75 6.625C1.75 3.93261 3.93261 1.75 6.625 1.75Z"
      fill="#8181A5"
    />
  </svg>
);
export const GreenTickIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_9170_36323)">
      <path
        d="M16.5 8.31039V9.00039C16.4991 10.6177 15.9754 12.1914 15.007 13.4868C14.0386 14.7821 12.6775 15.7297 11.1265 16.1883C9.57557 16.6469 7.91794 16.5918 6.40085 16.0313C4.88376 15.4708 3.58849 14.435 2.70822 13.0782C1.82795 11.7214 1.40984 10.1164 1.51626 8.50262C1.62267 6.88881 2.24791 5.35263 3.29871 4.12319C4.34951 2.89375 5.76959 2.03692 7.34714 1.6805C8.92469 1.32407 10.5752 1.48714 12.0525 2.14539"
        stroke="#1CB161"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.5 3L9 10.5075L6.75 8.2575"
        stroke="#1CB161"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_9170_36323">
        <rect width="18" height="18" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export const PurpleAddBtn = () => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="30" height="30" rx="8" fill="#F5F4FF" />
    <path
      d="M15 10.917V19.0837"
      stroke="#7D63EC"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.916 15H19.0827"
      stroke="#7D63EC"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const EditPenIcon = () => (
  <svg
    width="15"
    height="14"
    viewBox="0 0 15 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.1152 1.74985C10.2684 1.59664 10.4503 1.47511 10.6505 1.39219C10.8507 1.30928 11.0652 1.2666 11.2819 1.2666C11.4986 1.2666 11.7131 1.30928 11.9133 1.39219C12.1135 1.47511 12.2954 1.59664 12.4486 1.74985C12.6018 1.90306 12.7233 2.08494 12.8062 2.28512C12.8891 2.4853 12.9318 2.69985 12.9318 2.91652C12.9318 3.13319 12.8891 3.34774 12.8062 3.54791C12.7233 3.74809 12.6018 3.92998 12.4486 4.08318L4.57357 11.9582L1.36523 12.8332L2.24023 9.62485L10.1152 1.74985Z"
      fill="#8181A5"
    />
  </svg>
);
export const CrossIcon = () => (
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.1992 4L4.19922 12"
      stroke="#8181A5"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.19922 4L12.1992 12"
      stroke="#8181A5"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const DangerIconBlack = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_15642_212137)">
      <path
        d="M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5Z"
        stroke="#58596B"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 12V9"
        stroke="#8181A5"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 6H9.0075"
        stroke="#8181A5"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_15642_212137">
        <rect width="18" height="18" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export const PlusIconPurple = ({ color }) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 2.5V9.5"
      stroke={color || "#7D63EC"}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.5 6H9.5"
      stroke={color || "#7D63EC"}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const PlusIconGreen = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 3.33301V12.6663"
      stroke="#008381"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.33398 8H12.6673"
      stroke="#008381"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const DocumentIcon = () => (
  <svg
    width="14"
    height="18"
    viewBox="0 0 14 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 16L1 2C1 1.44771 1.44772 0.999999 2 0.999999L8.71429 1L12 1C12.5523 1 13 1.44772 13 2L13 8.33333L13 16C13 16.5523 12.5523 17 12 17L4.42857 17L2 17C1.44772 17 1 16.5523 1 16Z"
      stroke="#556080"
    />
    <path d="M3.25 3.7998H10.75" stroke="#556080" />
    <path d="M3.25 6.60059H10.75" stroke="#556080" />
    <path d="M3.25 9.40039H10.75" stroke="#556080" />
    <path d="M3.25 12.2002H7" stroke="#556080" />
  </svg>
);
export const ViewIconPurple = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="32" height="32" rx="8" fill="white" />
    <rect width="32" height="32" rx="8" fill="#5E81F4" fillOpacity="0.1" />
    <path
      d="M8.66602 16.0003C8.66602 16.0003 11.3327 10.667 15.9993 10.667C20.666 10.667 23.3327 16.0003 23.3327 16.0003C23.3327 16.0003 20.666 21.3337 15.9993 21.3337C11.3327 21.3337 8.66602 16.0003 8.66602 16.0003Z"
      stroke="#7D63EC"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 18C17.1046 18 18 17.1046 18 16C18 14.8954 17.1046 14 16 14C14.8954 14 14 14.8954 14 16C14 17.1046 14.8954 18 16 18Z"
      stroke="#7D63EC"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const EditIconPurple = () => (
  <svg
    width="32"
    height="33"
    viewBox="0 0 32 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect y="0.152344" width="32" height="32" rx="8" fill="white" />
    <rect
      y="0.152344"
      width="32"
      height="32"
      rx="8"
      fill="#5E81F4"
      fillOpacity="0.1"
    />
    <path
      d="M16 21.4854H22"
      stroke="#7D63EC"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19 10.4855C19.2652 10.2203 19.6249 10.0713 20 10.0713C20.1857 10.0713 20.3696 10.1079 20.5412 10.1789C20.7128 10.25 20.8687 10.3542 21 10.4855C21.1313 10.6168 21.2355 10.7727 21.3066 10.9443C21.3776 11.1159 21.4142 11.2998 21.4142 11.4855C21.4142 11.6712 21.3776 11.8551 21.3066 12.0267C21.2355 12.1983 21.1313 12.3542 21 12.4855L12.6667 20.8188L10 21.4855L10.6667 18.8188L19 10.4855Z"
      stroke="#7D63EC"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const DeleteIconPurple = () => (
  <svg
    width="32"
    height="33"
    viewBox="0 0 32 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect y="0.303711" width="32" height="32" rx="8" fill="white" />
    <rect
      y="0.303711"
      width="32"
      height="32"
      rx="8"
      fill="#5E81F4"
      fillOpacity="0.1"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.334 8.9707C18.3991 8.9707 19.2698 9.80332 19.3306 10.8532L19.334 10.9707V11.6374H20.6673H22.0007C22.3688 11.6374 22.6673 11.9358 22.6673 12.304C22.6673 12.6459 22.41 12.9277 22.0784 12.9662L22.0007 12.9707H21.334V21.6374C21.334 22.7025 20.5014 23.5731 19.4515 23.634L19.334 23.6374H12.6673C11.6022 23.6374 10.7315 22.8048 10.6707 21.7549L10.6673 21.6374V12.9707H10.0007C9.63246 12.9707 9.33398 12.6722 9.33398 12.304C9.33398 11.9621 9.59134 11.6804 9.9229 11.6419L10.0007 11.6374H11.334H12.6673V10.9707C12.6673 9.90558 13.4999 9.03493 14.5498 8.9741L14.6673 8.9707H17.334ZM13.334 12.9707H12.0007V21.6374C12.0007 21.9793 12.258 22.261 12.5896 22.2996L12.6673 22.304H19.334C19.6759 22.304 19.9577 22.0467 19.9962 21.7151L20.0007 21.6374V12.9707H18.6673H13.334ZM18.0007 11.6374H14.0007V10.9707L14.0051 10.893C14.0436 10.5614 14.3254 10.304 14.6673 10.304H17.334L17.4117 10.3085C17.7433 10.347 18.0007 10.6288 18.0007 10.9707V11.6374ZM14.6673 14.9707C15.0092 14.9707 15.291 15.2281 15.3295 15.5596L15.334 15.6374V19.6374C15.334 20.0056 15.0355 20.304 14.6673 20.304C14.3254 20.304 14.0436 20.0467 14.0051 19.7151L14.0007 19.6374V15.6374C14.0007 15.2692 14.2991 14.9707 14.6673 14.9707ZM17.9962 15.5596C17.9577 15.2281 17.6759 14.9707 17.334 14.9707C16.9658 14.9707 16.6673 15.2692 16.6673 15.6374V19.6374L16.6718 19.7151C16.7103 20.0467 16.9921 20.304 17.334 20.304C17.7022 20.304 18.0007 20.0056 18.0007 19.6374V15.6374L17.9962 15.5596Z"
      fill="#7D63EC"
    />
  </svg>
);
export const ThreeDotIcon = () => (
  <svg
    width="4"
    height="16"
    viewBox="0 0 4 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 4C3.1 4 4 3.1 4 2C4 0.9 3.1 0 2 0C0.9 0 0 0.9 0 2C0 3.1 0.9 4 2 4ZM2 6C0.9 6 0 6.9 0 8C0 9.1 0.9 10 2 10C3.1 10 4 9.1 4 8C4 6.9 3.1 6 2 6ZM2 12C0.9 12 0 12.9 0 14C0 15.1 0.9 16 2 16C3.1 16 4 15.1 4 14C4 12.9 3.1 12 2 12Z"
      fill="#7B86AD"
    />
  </svg>
);
export const RightArrowWhite = () => (
  <svg
    width="6"
    height="10"
    viewBox="0 0 6 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.75 9.5L5.25 5L0.75 0.5"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const LogoutIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.5333 12.1833L16.6667 10.05L14.5333 7.91666"
      stroke="#433F5C"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.1333 10.05H16.6083"
      stroke="#433F5C"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.79997 16.6667C6.11663 16.6667 3.1333 14.1667 3.1333 10C3.1333 5.83334 6.11663 3.33334 9.79997 3.33334"
      stroke="#433F5C"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const ProfileIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.1334 9.05832C10.05 9.04999 9.95005 9.04999 9.85838 9.05832C7.87505 8.99166 6.30005 7.36666 6.30005 5.36666C6.30005 3.32499 7.95005 1.66666 10 1.66666C12.0417 1.66666 13.7001 3.32499 13.7001 5.36666C13.6917 7.36666 12.1167 8.99166 10.1334 9.05832Z"
      stroke="#8181A5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.96672 12.1333C3.95006 13.4833 3.95006 15.6833 5.96672 17.025C8.25839 18.5583 12.0167 18.5583 14.3084 17.025C16.3251 15.675 16.3251 13.475 14.3084 12.1333C12.0251 10.6083 8.26672 10.6083 5.96672 12.1333Z"
      stroke="#8181A5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const RupeeIcon = () => (
  <svg
    width="10"
    height="12"
    viewBox="0 0 10 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.53005 1.34297C4.44045 1.33415 4.32612 1.33334 4.00065 1.33334H1.00067C0.632478 1.33334 0.334005 1.03486 0.334005 0.666673C0.334005 0.29848 0.632478 6.67572e-06 1.00067 6.67572e-06H4.00065C4.01372 6.67572e-06 4.02659 6.66667e-06 4.03925 0C4.06405 0 4.08812 9.05372e-09 4.11152 6.67572e-06H9.00065C9.36885 6.67572e-06 9.66732 0.29848 9.66732 0.666673C9.66732 1.03486 9.36885 1.33334 9.00065 1.33334H7.00078C7.29152 1.72063 7.49985 2.17361 7.60012 2.66667H9.00065C9.36885 2.66667 9.66732 2.96515 9.66732 3.33334C9.66732 3.70153 9.36885 4.00001 9.00065 4.00001H7.66625C7.66472 4.12555 7.66078 4.22997 7.65132 4.32673C7.49538 5.90933 6.24332 7.1614 4.66072 7.31727C4.49718 7.3334 4.31165 7.3334 4.03925 7.33333C4.02659 7.33333 4.01372 7.33333 4.00065 7.33333H2.61014L6.13872 10.8619C6.39912 11.1223 6.39912 11.5444 6.13872 11.8047C5.87838 12.0651 5.45625 12.0651 5.19592 11.8047L0.529265 7.13807C0.338598 6.9474 0.281565 6.66067 0.384751 6.41153C0.487938 6.16247 0.731031 6 1.00067 6H4.00065C4.32612 6 4.44045 5.9992 4.53005 5.9904C5.47958 5.89687 6.23085 5.1456 6.32438 4.19604C6.32912 4.14769 6.33158 4.09211 6.33278 4.00001H1.66734C1.29914 4.00001 1.00067 3.70153 1.00067 3.33334C1.00067 2.96515 1.29914 2.66667 1.66734 2.66667H6.21985C5.96618 1.94848 5.31605 1.42039 4.53005 1.34297Z"
      fill="#8181A5"
    />
  </svg>
);
export const DeleteIconGrey = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M2 4H3.33333H14" fill="#888888" />
    <path
      d="M2 4H3.33333H14"
      stroke="#A2A2B1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.33398 3.99998V2.66665C5.33398 2.31302 5.47446 1.97389 5.72451 1.72384C5.97456 1.47379 6.3137 1.33331 6.66732 1.33331H9.33398C9.68761 1.33331 10.0267 1.47379 10.2768 1.72384C10.5268 1.97389 10.6673 2.31302 10.6673 2.66665V3.99998M12.6673 3.99998V13.3333C12.6673 13.6869 12.5268 14.0261 12.2768 14.2761C12.0267 14.5262 11.6876 14.6666 11.334 14.6666H4.66732C4.3137 14.6666 3.97456 14.5262 3.72451 14.2761C3.47446 14.0261 3.33398 13.6869 3.33398 13.3333V3.99998H12.6673Z"
      stroke="#A2A2B1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.66602 7.33331V11.3333"
      stroke="#A2A2B1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.33398 7.33331V11.3333"
      stroke="#A2A2B1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const InquiryIconWhite = () => (
  <svg
    width="14"
    height="17"
    viewBox="0 0 14 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.2491 5.64431H9.51978C9.12924 5.64431 8.75457 5.48869 8.47763 5.21144C8.20069 4.93419 8.04399 4.55785 8.04177 4.16465V1.40826V0.148438H1.9618C1.57271 0.150657 1.20019 0.307262 0.925062 0.584272C0.649933 0.861281 0.494392 1.23635 0.492188 1.62809V15.1564C0.494392 15.5481 0.649933 15.9232 0.925062 16.2002C1.20019 16.4772 1.57271 16.6338 1.9618 16.636H12.0391C12.4282 16.6338 12.8007 16.4772 13.0758 16.2002C13.351 15.9232 13.5065 15.5481 13.5087 15.1564V5.64431H12.2491ZM10.3596 7.7581C10.5266 7.7581 10.6868 7.82491 10.8049 7.94384C10.923 8.06276 10.9894 8.22406 10.9894 8.39224C10.9894 8.56042 10.923 8.72172 10.8049 8.84064C10.6868 8.95957 10.5266 9.02638 10.3596 9.02638H3.64135C3.47431 9.02638 3.31411 8.95957 3.19599 8.84064C3.07787 8.72172 3.01152 8.56042 3.01152 8.39224C3.01152 8.22406 3.07787 8.06276 3.19599 7.94384C3.31411 7.82491 3.47431 7.7581 3.64135 7.7581H10.3596ZM3.64135 12.8312H7.00045C7.16749 12.8312 7.32769 12.898 7.44581 13.0169C7.56393 13.1359 7.63028 13.2972 7.63028 13.4653C7.63028 13.6335 7.56393 13.7948 7.44581 13.9138C7.32769 14.0327 7.16749 14.0995 7.00045 14.0995H3.64135C3.47431 14.0995 3.31411 14.0327 3.19599 13.9138C3.07787 13.7948 3.01152 13.6335 3.01152 13.4653C3.01152 13.2972 3.07787 13.1359 3.19599 13.0169C3.31411 12.898 3.47431 12.8312 3.64135 12.8312ZM3.01152 10.9288C3.01369 10.7613 3.08075 10.6013 3.19839 10.4828C3.31604 10.3644 3.47498 10.2968 3.64135 10.2947H10.3596C10.5266 10.2947 10.6868 10.3615 10.8049 10.4804C10.923 10.5993 10.9894 10.7606 10.9894 10.9288C10.9894 11.097 10.923 11.2583 10.8049 11.3772C10.6868 11.4961 10.5266 11.5629 10.3596 11.5629H3.64135C3.47498 11.5607 3.31604 11.4932 3.19839 11.3748C3.08075 11.2563 3.01369 11.0963 3.01152 10.9288Z"
      fill="white"
    />
    <path
      d="M9.5203 4.37539H13.5092C13.4812 4.03298 13.3322 3.71203 13.0893 3.47068L10.2089 0.579009C9.96147 0.330884 9.63354 0.180804 9.28516 0.15625V1.45835V4.16401C9.28495 4.19403 9.29109 4.22376 9.30318 4.25122C9.31527 4.27867 9.33303 4.30321 9.35527 4.32321C9.37752 4.34321 9.40375 4.35821 9.4322 4.3672C9.46066 4.3762 9.49069 4.37899 9.5203 4.37539Z"
      fill="white"
    />
  </svg>
);
export const VenueIconGrey = () => (
  <svg
    width="20"
    height="17"
    viewBox="0 0 20 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.47957 16.1974C4.48599 16.4133 4.31618 16.5916 4.10496 16.5916H2.12987C1.302 16.5916 0.630859 15.9052 0.630859 15.0585V7.39312C0.630859 6.54643 1.302 5.86004 2.12987 5.86004H4.09732C4.30428 5.86004 4.47208 6.03203 4.47208 6.24369C4.47166 13.4616 4.45985 15.5361 4.47957 16.1974ZM3.20729 9.69274C3.20729 9.48108 3.03949 9.30947 2.83253 9.30947C2.62558 9.30947 2.45778 9.48108 2.45778 9.69274V11.3216C2.45778 11.5333 2.62558 11.7049 2.83253 11.7049C3.03949 11.7049 3.20729 11.5333 3.20729 11.3216V9.69274ZM19.3685 7.39312V15.0585C19.3685 15.9052 18.6974 16.5916 17.8695 16.5916H15.8947C15.6836 16.5916 15.5137 16.4132 15.5201 16.1974C15.5399 15.5372 15.5277 13.4658 15.5273 6.24369C15.5273 6.03203 15.6951 5.86004 15.902 5.86004H17.8695C18.6974 5.86004 19.3685 6.54643 19.3685 7.39312ZM17.5416 9.69274C17.5416 9.48108 17.3738 9.30947 17.1668 9.30947C16.9599 9.30947 16.7921 9.48108 16.7921 9.69274V11.3216C16.7921 11.5333 16.9599 11.7049 17.1668 11.7049C17.3738 11.7049 17.5416 11.5333 17.5416 11.3216V9.69274ZM9.0628 16.5916H10.9366C11.1435 16.5916 11.3113 16.42 11.3113 16.2083V12.6152C11.3113 12.4035 11.1435 12.2319 10.9366 12.2319H9.0628C8.85584 12.2319 8.68805 12.4035 8.68805 12.6152V16.2083C8.68805 16.42 8.85584 16.5916 9.0628 16.5916ZM14.7778 1.93152V16.2083C14.7778 16.42 14.61 16.5916 14.403 16.5916H12.4356C12.2286 16.5916 12.0608 16.42 12.0608 16.2083V11.8486C12.0608 11.637 11.893 11.4654 11.6861 11.4654H8.3133C8.10634 11.4654 7.93854 11.637 7.93854 11.8486V16.2083C7.93854 16.42 7.77075 16.5916 7.56379 16.5916H5.59634C5.38938 16.5916 5.22158 16.42 5.22158 16.2083V1.93152C5.22158 1.08483 5.89272 0.398438 6.7206 0.398438H13.2788C14.1067 0.398438 14.7778 1.08483 14.7778 1.93152ZM11.8734 8.35129C11.8734 8.13963 11.7057 7.96802 11.4987 7.96802H8.50067C8.29371 7.96802 8.12592 8.13963 8.12592 8.35129C8.12592 8.56295 8.29371 8.73456 8.50067 8.73456H11.4987C11.7057 8.73456 11.8734 8.56295 11.8734 8.35129ZM12.5293 4.66232C12.5293 4.45066 12.3615 4.27905 12.1545 4.27905H7.84485C7.6379 4.27905 7.4701 4.45066 7.4701 4.66232C7.4701 4.87398 7.6379 5.04559 7.84485 5.04559H12.1545C12.3615 5.04559 12.5293 4.87398 12.5293 4.66232Z"
      fill="#ABB2B3"
    />
  </svg>
);
export const VenueGray = () => (
  <svg
    width="15"
    height="16"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.47957 16.1974C4.48599 16.4133 4.31618 16.5916 4.10496 16.5916H2.12987C1.302 16.5916 0.630859 15.9052 0.630859 15.0585V7.39312C0.630859 6.54643 1.302 5.86004 2.12987 5.86004H4.09732C4.30428 5.86004 4.47208 6.03203 4.47208 6.24369C4.47166 13.4616 4.45985 15.5361 4.47957 16.1974ZM3.20729 9.69274C3.20729 9.48108 3.03949 9.30947 2.83253 9.30947C2.62558 9.30947 2.45778 9.48108 2.45778 9.69274V11.3216C2.45778 11.5333 2.62558 11.7049 2.83253 11.7049C3.03949 11.7049 3.20729 11.5333 3.20729 11.3216V9.69274ZM19.3685 7.39312V15.0585C19.3685 15.9052 18.6974 16.5916 17.8695 16.5916H15.8947C15.6836 16.5916 15.5137 16.4132 15.5201 16.1974C15.5399 15.5372 15.5277 13.4658 15.5273 6.24369C15.5273 6.03203 15.6951 5.86004 15.902 5.86004H17.8695C18.6974 5.86004 19.3685 6.54643 19.3685 7.39312ZM17.5416 9.69274C17.5416 9.48108 17.3738 9.30947 17.1668 9.30947C16.9599 9.30947 16.7921 9.48108 16.7921 9.69274V11.3216C16.7921 11.5333 16.9599 11.7049 17.1668 11.7049C17.3738 11.7049 17.5416 11.5333 17.5416 11.3216V9.69274ZM9.0628 16.5916H10.9366C11.1435 16.5916 11.3113 16.42 11.3113 16.2083V12.6152C11.3113 12.4035 11.1435 12.2319 10.9366 12.2319H9.0628C8.85584 12.2319 8.68805 12.4035 8.68805 12.6152V16.2083C8.68805 16.42 8.85584 16.5916 9.0628 16.5916ZM14.7778 1.93152V16.2083C14.7778 16.42 14.61 16.5916 14.403 16.5916H12.4356C12.2286 16.5916 12.0608 16.42 12.0608 16.2083V11.8486C12.0608 11.637 11.893 11.4654 11.6861 11.4654H8.3133C8.10634 11.4654 7.93854 11.637 7.93854 11.8486V16.2083C7.93854 16.42 7.77075 16.5916 7.56379 16.5916H5.59634C5.38938 16.5916 5.22158 16.42 5.22158 16.2083V1.93152C5.22158 1.08483 5.89272 0.398438 6.7206 0.398438H13.2788C14.1067 0.398438 14.7778 1.08483 14.7778 1.93152ZM11.8734 8.35129C11.8734 8.13963 11.7057 7.96802 11.4987 7.96802H8.50067C8.29371 7.96802 8.12592 8.13963 8.12592 8.35129C8.12592 8.56295 8.29371 8.73456 8.50067 8.73456H11.4987C11.7057 8.73456 11.8734 8.56295 11.8734 8.35129ZM12.5293 4.66232C12.5293 4.45066 12.3615 4.27905 12.1545 4.27905H7.84485C7.6379 4.27905 7.4701 4.45066 7.4701 4.66232C7.4701 4.87398 7.6379 5.04559 7.84485 5.04559H12.1545C12.3615 5.04559 12.5293 4.87398 12.5293 4.66232Z"
      fill="#ABB2B3"
    />
  </svg>
);
export const ReviewIconGrey = () => (
  <svg
    width="14"
    height="17"
    viewBox="0 0 14 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.8664 0.525157C12.6157 0.409681 12.3204 0.454616 12.1154 0.639347L11.0337 1.5971C11.0043 1.62329 10.9599 1.62314 10.9306 1.59679L9.45885 0.280447C9.19267 0.0419342 8.78969 0.0419342 8.52351 0.280447L7.05306 1.59558C7.02348 1.62201 6.97878 1.62201 6.9492 1.59558L5.47861 0.280447C5.21242 0.0419732 4.80944 0.0419732 4.54326 0.280447L3.0713 1.59679C3.04184 1.62314 2.99733 1.62325 2.96771 1.59706L1.88505 0.639347C1.59782 0.38392 1.15789 0.409681 0.902467 0.69691C0.787926 0.825715 0.725258 0.99244 0.726583 1.16478V15.526C0.724011 15.911 1.034 16.2251 1.41897 16.2277C1.59143 16.2289 1.75815 16.166 1.887 16.0514L2.96868 15.0937C2.99811 15.0675 3.0425 15.0676 3.07177 15.094L4.54353 16.4103C4.80972 16.6488 5.21269 16.6488 5.47888 16.4103L6.94947 15.0952C6.97905 15.0688 7.02376 15.0688 7.05334 15.0952L8.52393 16.4103C8.79016 16.6487 9.1931 16.6487 9.45928 16.4103L10.9313 15.0939C10.9608 15.0676 11.0053 15.0675 11.0349 15.0937L12.1176 16.0514C12.4049 16.3067 12.8448 16.2807 13.1001 15.9934C13.2145 15.8647 13.277 15.6982 13.2758 15.526V1.16478C13.2795 0.88889 13.1184 0.637321 12.8664 0.525157ZM3.30685 5.69524H7.18799C7.36017 5.69524 7.49977 5.83484 7.49977 6.00702C7.49977 6.1792 7.36017 6.3188 7.18799 6.3188H3.30685C3.13467 6.3188 2.99507 6.1792 2.99507 6.00702C2.99507 5.83484 3.13467 5.69524 3.30685 5.69524ZM10.6955 10.9955H3.30685C3.13467 10.9955 2.99507 10.8559 2.99507 10.6837C2.99507 10.5116 3.13467 10.372 3.30685 10.372H10.6955C10.8677 10.372 11.0073 10.5116 11.0073 10.6837C11.0073 10.8559 10.8677 10.9955 10.6955 10.9955ZM10.6955 8.65717H3.30685C3.13467 8.65717 2.99507 8.51757 2.99507 8.34539C2.99507 8.1732 3.13467 8.0336 3.30685 8.0336H10.6955C10.8677 8.0336 11.0073 8.1732 11.0073 8.34539C11.0073 8.51757 10.8677 8.65717 10.6955 8.65717Z"
      fill="#ABB2B3"
    />
  </svg>
);
export const VenueIconWhite = () => (
  <svg
    width="20"
    height="17"
    viewBox="0 0 20 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.47957 16.2443C4.48599 16.4602 4.31618 16.6385 4.10496 16.6385H2.12987C1.302 16.6385 0.630859 15.9521 0.630859 15.1054V7.43999C0.630859 6.5933 1.302 5.90691 2.12987 5.90691H4.09732C4.30428 5.90691 4.47208 6.0789 4.47208 6.29057C4.47166 13.5085 4.45985 15.583 4.47957 16.2443ZM3.20729 9.73961C3.20729 9.52795 3.03949 9.35634 2.83253 9.35634C2.62558 9.35634 2.45778 9.52795 2.45778 9.73961V11.3685C2.45778 11.5802 2.62558 11.7518 2.83253 11.7518C3.03949 11.7518 3.20729 11.5802 3.20729 11.3685V9.73961ZM19.3685 7.43999V15.1054C19.3685 15.9521 18.6974 16.6385 17.8695 16.6385H15.8947C15.6836 16.6385 15.5137 16.4601 15.5201 16.2442C15.5399 15.5841 15.5277 13.5127 15.5273 6.29057C15.5273 6.0789 15.6951 5.90691 15.902 5.90691H17.8695C18.6974 5.90691 19.3685 6.5933 19.3685 7.43999ZM17.5416 9.73961C17.5416 9.52795 17.3738 9.35634 17.1668 9.35634C16.9599 9.35634 16.7921 9.52795 16.7921 9.73961V11.3685C16.7921 11.5802 16.9599 11.7518 17.1668 11.7518C17.3738 11.7518 17.5416 11.5802 17.5416 11.3685V9.73961ZM9.0628 16.6385H10.9366C11.1435 16.6385 11.3113 16.4669 11.3113 16.2552V12.662C11.3113 12.4504 11.1435 12.2788 10.9366 12.2788H9.0628C8.85584 12.2788 8.68805 12.4504 8.68805 12.662V16.2552C8.68805 16.4669 8.85584 16.6385 9.0628 16.6385ZM14.7778 1.97839V16.2552C14.7778 16.4669 14.61 16.6385 14.403 16.6385H12.4356C12.2286 16.6385 12.0608 16.4669 12.0608 16.2552V11.8955C12.0608 11.6838 11.893 11.5122 11.6861 11.5122H8.3133C8.10634 11.5122 7.93854 11.6838 7.93854 11.8955V16.2552C7.93854 16.4669 7.77075 16.6385 7.56379 16.6385H5.59634C5.38938 16.6385 5.22158 16.4669 5.22158 16.2552V1.97839C5.22158 1.1317 5.89272 0.445312 6.7206 0.445312H13.2788C14.1067 0.445312 14.7778 1.1317 14.7778 1.97839ZM11.8734 8.39817C11.8734 8.18651 11.7057 8.0149 11.4987 8.0149H8.50067C8.29372 8.0149 8.12592 8.18651 8.12592 8.39817C8.12592 8.60983 8.29372 8.78144 8.50067 8.78144H11.4987C11.7057 8.78144 11.8734 8.60983 11.8734 8.39817ZM12.5293 4.70919C12.5293 4.49753 12.3615 4.32592 12.1545 4.32592H7.84485C7.6379 4.32592 7.4701 4.49753 7.4701 4.70919C7.4701 4.92085 7.6379 5.09246 7.84485 5.09246H12.1545C12.3615 5.09246 12.5293 4.92085 12.5293 4.70919Z"
      fill="white"
    />
  </svg>
);

export const VenueIconPurple = () => (
  <svg
    width="16"
    height="14"
    viewBox="0 0 16 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.37403 13.6688C3.3794 13.8497 3.23709 13.9991 3.06006 13.9991H1.40475C0.710913 13.9991 0.148438 13.4239 0.148438 12.7143V6.28994C0.148438 5.58033 0.710913 5.00507 1.40475 5.00507H3.05367C3.22712 5.00507 3.36774 5.14922 3.36774 5.32661C3.36763 7.35475 3.36643 8.89835 3.36553 10.0752C3.36373 12.4086 3.36304 13.3004 3.37403 13.6688ZM2.30773 8.21724C2.30773 8.03985 2.1671 7.89603 1.99365 7.89603C1.8202 7.89603 1.67957 8.03985 1.67957 8.21724V9.58241C1.67957 9.75981 1.8202 9.90363 1.99365 9.90363C2.1671 9.90363 2.30773 9.75981 2.30773 9.58241V8.21724ZM15.8524 6.28994V12.7143C15.8524 13.4239 15.2899 13.9991 14.5961 13.9991H12.941C12.764 13.9991 12.6216 13.8497 12.6271 13.6687C12.638 13.3042 12.6373 12.4263 12.6354 10.1387C12.6345 8.95416 12.6332 7.39161 12.6331 5.32661C12.6331 5.14922 12.7737 5.00507 12.9471 5.00507H14.5961C15.2899 5.00507 15.8524 5.58033 15.8524 6.28994ZM14.3212 8.21724C14.3212 8.03985 14.1806 7.89603 14.0072 7.89603C13.8337 7.89603 13.6931 8.03985 13.6931 8.21724V9.58241C13.6931 9.75981 13.8337 9.90363 14.0072 9.90363C14.1806 9.90363 14.3212 9.75981 14.3212 9.58241V8.21724ZM7.21521 13.9991H8.7856C8.95905 13.9991 9.09968 13.8553 9.09968 13.6779V10.6665C9.09968 10.4891 8.95905 10.3453 8.7856 10.3453H7.21521C7.04176 10.3453 6.90113 10.4891 6.90113 10.6665V13.6779C6.90113 13.8553 7.04176 13.9991 7.21521 13.9991ZM12.0049 1.7126V13.6779C12.0049 13.8553 11.8643 13.9991 11.6908 13.9991H10.0419C9.86847 13.9991 9.72784 13.8553 9.72784 13.6779V10.0241C9.72784 9.84669 9.58721 9.70287 9.41376 9.70287H6.58705C6.4136 9.70287 6.27297 9.84669 6.27297 10.0241V13.6779C6.27297 13.8553 6.13234 13.9991 5.95889 13.9991H4.30998C4.13653 13.9991 3.9959 13.8553 3.9959 13.6779V1.7126C3.9959 1.00299 4.55838 0.427734 5.25222 0.427734H10.7486C11.4425 0.427734 12.0049 1.00299 12.0049 1.7126ZM9.5708 7.09298C9.5708 6.91559 9.43017 6.77177 9.25672 6.77177H6.74409C6.57064 6.77177 6.43001 6.91559 6.43001 7.09298C6.43001 7.27038 6.57064 7.4142 6.74409 7.4142H9.25672C9.43021 7.4142 9.5708 7.27038 9.5708 7.09298ZM10.1204 4.00127C10.1204 3.82388 9.97981 3.68005 9.80636 3.68005H6.19445C6.021 3.68005 5.88037 3.82388 5.88037 4.00127C5.88037 4.17866 6.021 4.32249 6.19445 4.32249H9.80636C9.97985 4.32249 10.1204 4.17866 10.1204 4.00127Z"
      fill="#7D63EC"
    />
    <path
      d="M3.37403 13.6688C3.3794 13.8497 3.23709 13.9991 3.06006 13.9991H1.40475C0.710913 13.9991 0.148438 13.4239 0.148438 12.7143V6.28994C0.148438 5.58033 0.710913 5.00507 1.40475 5.00507H3.05367C3.22712 5.00507 3.36774 5.14922 3.36774 5.32661C3.36763 7.35475 3.36643 8.89835 3.36553 10.0752C3.36373 12.4086 3.36304 13.3004 3.37403 13.6688ZM2.30773 8.21724C2.30773 8.03985 2.1671 7.89603 1.99365 7.89603C1.8202 7.89603 1.67957 8.03985 1.67957 8.21724V9.58241C1.67957 9.75981 1.8202 9.90363 1.99365 9.90363C2.1671 9.90363 2.30773 9.75981 2.30773 9.58241V8.21724ZM15.8524 6.28994V12.7143C15.8524 13.4239 15.2899 13.9991 14.5961 13.9991H12.941C12.764 13.9991 12.6216 13.8497 12.6271 13.6687C12.638 13.3042 12.6373 12.4263 12.6354 10.1387C12.6345 8.95416 12.6332 7.39161 12.6331 5.32661C12.6331 5.14922 12.7737 5.00507 12.9471 5.00507H14.5961C15.2899 5.00507 15.8524 5.58033 15.8524 6.28994ZM14.3212 8.21724C14.3212 8.03985 14.1806 7.89603 14.0072 7.89603C13.8337 7.89603 13.6931 8.03985 13.6931 8.21724V9.58241C13.6931 9.75981 13.8337 9.90363 14.0072 9.90363C14.1806 9.90363 14.3212 9.75981 14.3212 9.58241V8.21724ZM7.21521 13.9991H8.7856C8.95905 13.9991 9.09968 13.8553 9.09968 13.6779V10.6665C9.09968 10.4891 8.95905 10.3453 8.7856 10.3453H7.21521C7.04176 10.3453 6.90113 10.4891 6.90113 10.6665V13.6779C6.90113 13.8553 7.04176 13.9991 7.21521 13.9991ZM12.0049 1.7126V13.6779C12.0049 13.8553 11.8643 13.9991 11.6908 13.9991H10.0419C9.86847 13.9991 9.72784 13.8553 9.72784 13.6779V10.0241C9.72784 9.84669 9.58721 9.70287 9.41376 9.70287H6.58705C6.4136 9.70287 6.27297 9.84669 6.27297 10.0241V13.6779C6.27297 13.8553 6.13234 13.9991 5.95889 13.9991H4.30998C4.13653 13.9991 3.9959 13.8553 3.9959 13.6779V1.7126C3.9959 1.00299 4.55838 0.427734 5.25222 0.427734H10.7486C11.4425 0.427734 12.0049 1.00299 12.0049 1.7126ZM9.5708 7.09298C9.5708 6.91559 9.43017 6.77177 9.25672 6.77177H6.74409C6.57064 6.77177 6.43001 6.91559 6.43001 7.09298C6.43001 7.27038 6.57064 7.4142 6.74409 7.4142H9.25672C9.43021 7.4142 9.5708 7.27038 9.5708 7.09298ZM10.1204 4.00127C10.1204 3.82388 9.97981 3.68005 9.80636 3.68005H6.19445C6.021 3.68005 5.88037 3.82388 5.88037 4.00127C5.88037 4.17866 6.021 4.32249 6.19445 4.32249H9.80636C9.97985 4.32249 10.1204 4.17866 10.1204 4.00127Z"
      stroke="white"
    />
  </svg>
);
export const ReviewIconWhite = () => (
  <svg
    width="14"
    height="17"
    viewBox="0 0 14 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.8664 0.525157C12.6157 0.409681 12.3204 0.454616 12.1154 0.639347L11.0337 1.5971C11.0043 1.62329 10.9599 1.62314 10.9306 1.59679L9.45885 0.280447C9.19267 0.0419342 8.78969 0.0419342 8.52351 0.280447L7.05306 1.59558C7.02348 1.62201 6.97878 1.62201 6.9492 1.59558L5.47861 0.280447C5.21242 0.0419732 4.80944 0.0419732 4.54326 0.280447L3.0713 1.59679C3.04184 1.62314 2.99733 1.62325 2.96771 1.59706L1.88505 0.639347C1.59782 0.38392 1.15789 0.409681 0.902467 0.69691C0.787926 0.825715 0.725258 0.99244 0.726583 1.16478V15.526C0.724011 15.911 1.034 16.2251 1.41897 16.2277C1.59143 16.2289 1.75815 16.166 1.887 16.0514L2.96868 15.0937C2.99811 15.0675 3.0425 15.0676 3.07177 15.094L4.54353 16.4103C4.80972 16.6488 5.21269 16.6488 5.47888 16.4103L6.94947 15.0952C6.97905 15.0688 7.02376 15.0688 7.05334 15.0952L8.52393 16.4103C8.79016 16.6487 9.1931 16.6487 9.45928 16.4103L10.9313 15.0939C10.9608 15.0676 11.0053 15.0675 11.0349 15.0937L12.1176 16.0514C12.4049 16.3067 12.8448 16.2807 13.1001 15.9934C13.2145 15.8647 13.277 15.6982 13.2758 15.526V1.16478C13.2795 0.88889 13.1184 0.637321 12.8664 0.525157ZM3.30685 5.69524H7.18799C7.36017 5.69524 7.49977 5.83484 7.49977 6.00702C7.49977 6.1792 7.36017 6.3188 7.18799 6.3188H3.30685C3.13467 6.3188 2.99507 6.1792 2.99507 6.00702C2.99507 5.83484 3.13467 5.69524 3.30685 5.69524ZM10.6955 10.9955H3.30685C3.13467 10.9955 2.99507 10.8559 2.99507 10.6837C2.99507 10.5116 3.13467 10.372 3.30685 10.372H10.6955C10.8677 10.372 11.0073 10.5116 11.0073 10.6837C11.0073 10.8559 10.8677 10.9955 10.6955 10.9955ZM10.6955 8.65717H3.30685C3.13467 8.65717 2.99507 8.51757 2.99507 8.34539C2.99507 8.1732 3.13467 8.0336 3.30685 8.0336H10.6955C10.8677 8.0336 11.0073 8.1732 11.0073 8.34539C11.0073 8.51757 10.8677 8.65717 10.6955 8.65717Z"
      fill="#FCFFFF"
    />
  </svg>
);
export const DeleteIconRedSolid = () => (
  <svg
    width="10"
    height="11"
    viewBox="0 0 10 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.44416 9.61429C1.44416 10.2661 1.97749 10.7995 2.62934 10.7995H7.37008C8.02193 10.7995 8.55527 10.2661 8.55527 9.61429V3.68837C8.55527 3.03652 8.02193 2.50318 7.37008 2.50318H2.62934C1.97749 2.50318 1.44416 3.03652 1.44416 3.68837V9.61429ZM8.55527 0.725405H7.07379L6.65304 0.304664C6.54638 0.197998 6.3923 0.132812 6.23823 0.132812H3.76119C3.60712 0.132812 3.45304 0.197998 3.34638 0.304664L2.92564 0.725405H1.44416C1.11823 0.725405 0.851562 0.992072 0.851562 1.318C0.851562 1.64392 1.11823 1.91059 1.44416 1.91059H8.55527C8.88119 1.91059 9.14786 1.64392 9.14786 1.318C9.14786 0.992072 8.88119 0.725405 8.55527 0.725405Z"
      fill="#EB5E5E"
    />
  </svg>
);
export const MarkReadIcon = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.5 5.5L6 7L11 2"
      stroke="#8181A5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.5 6V9.5C10.5 9.76522 10.3946 10.0196 10.2071 10.2071C10.0196 10.3946 9.76522 10.5 9.5 10.5H2.5C2.23478 10.5 1.98043 10.3946 1.79289 10.2071C1.60536 10.0196 1.5 9.76522 1.5 9.5V2.5C1.5 2.23478 1.60536 1.98043 1.79289 1.79289C1.98043 1.60536 2.23478 1.5 2.5 1.5H8"
      stroke="#8181A5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const AlertIconRed = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.71758 2.89393L1.36508 13.4989C1.2341 13.7257 1.1648 13.9829 1.16407 14.2448C1.16334 14.5067 1.23119 14.7643 1.3609 14.9918C1.4906 15.2194 1.67762 15.409 1.90336 15.5418C2.12909 15.6746 2.38568 15.7461 2.64758 15.7489H15.3526C15.6145 15.7461 15.8711 15.6746 16.0968 15.5418C16.3225 15.409 16.5096 15.2194 16.6393 14.9918C16.769 14.7643 16.8368 14.5067 16.8361 14.2448C16.8354 13.9829 16.766 13.7257 16.6351 13.4989L10.2826 2.89393C10.1489 2.67351 9.96062 2.49127 9.73597 2.3648C9.51133 2.23832 9.25788 2.17188 9.00008 2.17188C8.74227 2.17188 8.48882 2.23832 8.26418 2.3648C8.03954 2.49127 7.85128 2.67351 7.71758 2.89393Z"
      fill="#EB5E5E"
      stroke="#EB5E5E"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 6.75V9.75"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 12.75H9.0075"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const ProfileOutLineIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21"
      stroke="#433F5C"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z"
      stroke="#433F5C"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const MarkReadIconWhite = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_374_181804)">
      <path
        d="M14.6654 7.38527V7.99861C14.6645 9.43622 14.199 10.8351 13.3383 11.9865C12.4775 13.1379 11.2676 13.9803 9.88894 14.3879C8.51032 14.7955 7.03687 14.7465 5.68835 14.2483C4.33982 13.7501 3.18847 12.8293 2.406 11.6233C1.62354 10.4173 1.25189 8.99065 1.34648 7.55615C1.44107 6.12165 1.99684 4.75616 2.93088 3.66332C3.86493 2.57049 5.12722 1.80886 6.52949 1.49204C7.93176 1.17521 9.39888 1.32017 10.712 1.90527"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.6667 2.66797L8 9.3413L6 7.3413"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_374_181804">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export const NotifyIcon = () => (
  <svg
    width="20"
    height="20"
    className="me-2"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 4C9 3.20435 8.68393 2.44129 8.12132 1.87868C7.55871 1.31607 6.79565 1 6 1C5.20435 1 4.44129 1.31607 3.87868 1.87868C3.31607 2.44129 3 3.20435 3 4C3 7.5 1.5 8.5 1.5 8.5H10.5C10.5 8.5 9 7.5 9 4Z"
      stroke="#8181A5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.86501 10.5C6.7771 10.6515 6.65093 10.7773 6.49912 10.8648C6.34731 10.9522 6.1752 10.9982 6.00001 10.9982C5.82482 10.9982 5.6527 10.9522 5.5009 10.8648C5.34909 10.7773 5.22291 10.6515 5.13501 10.5"
      stroke="#8181A5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const CreatePlus = () => (
  <svg
    width="20"
    height="20"
    className="me-2"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 2.5V9.5"
      stroke="#8181A5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.5 6H9.5"
      stroke="#8181A5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const UpdateCalendar = () => (
  <svg
    width="20"
    height="20"
    className="me-2"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_241_12559)">
      <path
        d="M9.5 2H2.5C1.94772 2 1.5 2.44772 1.5 3V10C1.5 10.5523 1.94772 11 2.5 11H9.5C10.0523 11 10.5 10.5523 10.5 10V3C10.5 2.44772 10.0523 2 9.5 2Z"
        stroke="#8181A5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 1V3"
        stroke="#8181A5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 1V3"
        stroke="#8181A5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.5 5H10.5"
        stroke="#8181A5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_241_12559">
        <rect width="12" height="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export const PlusIconWhite = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 3.33203V12.6654"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.33203 8H12.6654"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const ActionToggle = ({ strokeColor }) => (
  <svg
    width="10"
    height="6"
    viewBox="0 0 10 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 1L5 5L9 1"
      stroke={strokeColor}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const ThreeDotAction = () => (
  <svg
    width="14"
    height="3"
    viewBox="0 0 14 3"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="12"
      cy="1.5"
      r="1.5"
      transform="rotate(90 12 1.5)"
      fill="#8181A5"
    />
    <circle
      cx="7"
      cy="1.5"
      r="1.5"
      transform="rotate(90 7 1.5)"
      fill="#8181A5"
    />
    <circle
      cx="2"
      cy="1.5"
      r="1.5"
      transform="rotate(90 2 1.5)"
      fill="#8181A5"
    />
  </svg>
);
export const ViewAction = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="32" height="32" rx="8" fill="white"></rect>
    <rect width="32" height="32" rx="8" fill="#5E81F4" fillOpacity="0.1"></rect>
    <path
      d="M8.66602 16.0003C8.66602 16.0003 11.3327 10.667 15.9993 10.667C20.666 10.667 23.3327 16.0003 23.3327 16.0003C23.3327 16.0003 20.666 21.3337 15.9993 21.3337C11.3327 21.3337 8.66602 16.0003 8.66602 16.0003Z"
      stroke="#7D63EC"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></path>
    <path
      d="M16 18C17.1046 18 18 17.1046 18 16C18 14.8954 17.1046 14 16 14C14.8954 14 14 14.8954 14 16C14 17.1046 14.8954 18 16 18Z"
      stroke="#7D63EC"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></path>
  </svg>
);
export const EditAction = () => (
  <svg
    width="32"
    height="33"
    viewBox="0 0 32 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect y="0.152344" width="32" height="32" rx="8" fill="white"></rect>
    <rect
      y="0.152344"
      width="32"
      height="32"
      rx="8"
      fill="#5E81F4"
      fillOpacity="0.1"
    ></rect>
    <path
      d="M16 21.4854H22"
      stroke="#7D63EC"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></path>
    <path
      d="M19 10.4855C19.2652 10.2203 19.6249 10.0713 20 10.0713C20.1857 10.0713 20.3696 10.1079 20.5412 10.1789C20.7128 10.25 20.8687 10.3542 21 10.4855C21.1313 10.6168 21.2355 10.7727 21.3066 10.9443C21.3776 11.1159 21.4142 11.2998 21.4142 11.4855C21.4142 11.6712 21.3776 11.8551 21.3066 12.0267C21.2355 12.1983 21.1313 12.3542 21 12.4855L12.6667 20.8188L10 21.4855L10.6667 18.8188L19 10.4855Z"
      stroke="#7D63EC"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></path>
  </svg>
);
export const DeleteAction = () => (
  <svg
    width="32"
    height="33"
    viewBox="0 0 32 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect y="0.303711" width="32" height="32" rx="8" fill="white"></rect>
    <rect
      y="0.303711"
      width="32"
      height="32"
      rx="8"
      fill="#5E81F4"
      fillOpacity="0.1"
    ></rect>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.334 8.9707C18.3991 8.9707 19.2698 9.80332 19.3306 10.8532L19.334 10.9707V11.6374H20.6673H22.0007C22.3688 11.6374 22.6673 11.9358 22.6673 12.304C22.6673 12.6459 22.41 12.9277 22.0784 12.9662L22.0007 12.9707H21.334V21.6374C21.334 22.7025 20.5014 23.5731 19.4515 23.634L19.334 23.6374H12.6673C11.6022 23.6374 10.7315 22.8048 10.6707 21.7549L10.6673 21.6374V12.9707H10.0007C9.63246 12.9707 9.33398 12.6722 9.33398 12.304C9.33398 11.9621 9.59134 11.6804 9.9229 11.6419L10.0007 11.6374H11.334H12.6673V10.9707C12.6673 9.90558 13.4999 9.03493 14.5498 8.9741L14.6673 8.9707H17.334ZM13.334 12.9707H12.0007V21.6374C12.0007 21.9793 12.258 22.261 12.5896 22.2996L12.6673 22.304H19.334C19.6759 22.304 19.9577 22.0467 19.9962 21.7151L20.0007 21.6374V12.9707H18.6673H13.334ZM18.0007 11.6374H14.0007V10.9707L14.0051 10.893C14.0436 10.5614 14.3254 10.304 14.6673 10.304H17.334L17.4117 10.3085C17.7433 10.347 18.0007 10.6288 18.0007 10.9707V11.6374ZM14.6673 14.9707C15.0092 14.9707 15.291 15.2281 15.3295 15.5596L15.334 15.6374V19.6374C15.334 20.0056 15.0355 20.304 14.6673 20.304C14.3254 20.304 14.0436 20.0467 14.0051 19.7151L14.0007 19.6374V15.6374C14.0007 15.2692 14.2991 14.9707 14.6673 14.9707ZM17.9962 15.5596C17.9577 15.2281 17.6759 14.9707 17.334 14.9707C16.9658 14.9707 16.6673 15.2692 16.6673 15.6374V19.6374L16.6718 19.7151C16.7103 20.0467 16.9921 20.304 17.334 20.304C17.7022 20.304 18.0007 20.0056 18.0007 19.6374V15.6374L17.9962 15.5596Z"
      fill="#7D63EC"
    ></path>
  </svg>
);
export const AddNewButtonIcon = () => (
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.5 3.3335V12.6668"
      stroke="#7D63EC"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></path>
    <path
      d="M3.83301 8H13.1663"
      stroke="#7D63EC"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></path>
  </svg>
);
export const CalenderIconGrey = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.6016 5.74219C10.6016 5.76808 10.5806 5.78906 10.5547 5.78906C10.5288 5.78906 10.5078 5.76808 10.5078 5.74219C10.5078 5.7163 10.5288 5.69531 10.5547 5.69531C10.5806 5.69531 10.6016 5.7163 10.6016 5.74219Z"
      fill="#F5F4FF"
      stroke="#7676B1"
    />
    <path
      d="M10.6016 1.09375V1.59375H11.1016H11.8125C12.7425 1.59375 13.5 2.3512 13.5 3.28125V6.39844C13.5 6.42433 13.479 6.44531 13.4531 6.44531C13.4272 6.44531 13.4062 6.42433 13.4062 6.39844V3.28125C13.4062 2.40201 12.6917 1.6875 11.8125 1.6875H11.1016H10.6016V2.1875V2.73438C10.6016 2.76027 10.5806 2.78125 10.5547 2.78125C10.5288 2.78125 10.5078 2.76027 10.5078 2.73438V2.1875V1.6875H10.0078H7.51953H7.01953V2.1875V2.73438C7.01953 2.76027 6.99855 2.78125 6.97266 2.78125C6.94676 2.78125 6.92578 2.76027 6.92578 2.73438V2.1875V1.6875H6.42578H3.96484H3.46484V2.1875V2.73438C3.46484 2.76027 3.44387 2.78125 3.41797 2.78125C3.39207 2.78125 3.37109 2.76027 3.37109 2.73438V2.1875V1.6875H2.87109H2.1875C1.30826 1.6875 0.59375 2.40201 0.59375 3.28125V11.8125C0.59375 12.6917 1.30826 13.4062 2.1875 13.4062H6.37109C6.39699 13.4062 6.41797 13.4272 6.41797 13.4531C6.41797 13.479 6.39699 13.5 6.37109 13.5H2.1875C1.25745 13.5 0.5 12.7425 0.5 11.8125V3.28125C0.5 2.3512 1.25745 1.59375 2.1875 1.59375H2.87109H3.37109V1.09375V0.546875C3.37109 0.520978 3.39207 0.5 3.41797 0.5C3.44387 0.5 3.46484 0.520978 3.46484 0.546875V1.09375V1.59375H3.96484H6.42578H6.92578V1.09375V0.546875C6.92578 0.520978 6.94676 0.5 6.97266 0.5C6.99855 0.5 7.01953 0.520978 7.01953 0.546875V1.09375V1.59375H7.51953H10.0078H10.5078V1.09375V0.546875C10.5078 0.520978 10.5288 0.5 10.5547 0.5C10.5806 0.5 10.6016 0.520978 10.6016 0.546875V1.09375Z"
      fill="#8181A5"
      stroke="#7676B1"
    />
    <path
      d="M7.88281 10.6914C7.88281 9.14317 9.14317 7.88281 10.6914 7.88281C12.2396 7.88281 13.5 9.14317 13.5 10.6914C13.5 12.2396 12.2396 13.5 10.6914 13.5C9.14317 13.5 7.88281 12.2396 7.88281 10.6914ZM7.97656 10.6914C7.97656 12.1888 9.19401 13.4062 10.6914 13.4062C12.1888 13.4062 13.4062 12.1888 13.4062 10.6914C13.4062 9.19398 12.1888 7.97656 10.6914 7.97656C9.19401 7.97656 7.97656 9.19398 7.97656 10.6914Z"
      fill="#8181A5"
      stroke="#7676B1"
    />
    <path
      d="M10.7383 10.1445V10.6445H11.2383H11.4844C11.5103 10.6445 11.5312 10.6655 11.5312 10.6914C11.5312 10.7173 11.5103 10.7383 11.4844 10.7383H10.6914C10.6655 10.7383 10.6445 10.7173 10.6445 10.6914V9.57031C10.6445 9.54442 10.6655 9.52344 10.6914 9.52344C10.7173 9.52344 10.7383 9.54442 10.7383 9.57031V10.1445Z"
      fill="#8181A5"
      stroke="#7676B1"
    />
    <path
      d="M8.17578 6.28906C8.47781 6.28906 8.72266 6.04422 8.72266 5.74219C8.72266 5.44016 8.47781 5.19531 8.17578 5.19531C7.87375 5.19531 7.62891 5.44016 7.62891 5.74219C7.62891 6.04422 7.87375 6.28906 8.17578 6.28906Z"
      fill="#8181A5"
    />
    <path
      d="M5.79688 8.66797C6.09891 8.66797 6.34375 8.42312 6.34375 8.12109C6.34375 7.81906 6.09891 7.57422 5.79688 7.57422C5.49484 7.57422 5.25 7.81906 5.25 8.12109C5.25 8.42312 5.49484 8.66797 5.79688 8.66797Z"
      fill="#8181A5"
    />
    <path
      d="M3.41797 6.28906C3.72 6.28906 3.96484 6.04422 3.96484 5.74219C3.96484 5.44016 3.72 5.19531 3.41797 5.19531C3.11594 5.19531 2.87109 5.44016 2.87109 5.74219C2.87109 6.04422 3.11594 6.28906 3.41797 6.28906Z"
      fill="#8181A5"
    />
    <path
      d="M3.41797 8.66797C3.72 8.66797 3.96484 8.42312 3.96484 8.12109C3.96484 7.81906 3.72 7.57422 3.41797 7.57422C3.11594 7.57422 2.87109 7.81906 2.87109 8.12109C2.87109 8.42312 3.11594 8.66797 3.41797 8.66797Z"
      fill="#8181A5"
    />
    <path
      d="M3.41797 11.0469C3.72 11.0469 3.96484 10.802 3.96484 10.5C3.96484 10.198 3.72 9.95312 3.41797 9.95312C3.11594 9.95312 2.87109 10.198 2.87109 10.5C2.87109 10.802 3.11594 11.0469 3.41797 11.0469Z"
      fill="#8181A5"
    />
    <path
      d="M5.79688 11.0469C6.09891 11.0469 6.34375 10.802 6.34375 10.5C6.34375 10.198 6.09891 9.95312 5.79688 9.95312C5.49484 9.95312 5.25 10.198 5.25 10.5C5.25 10.802 5.49484 11.0469 5.79688 11.0469Z"
      fill="#8181A5"
    />
    <path
      d="M5.79688 6.28906C6.09891 6.28906 6.34375 6.04422 6.34375 5.74219C6.34375 5.44016 6.09891 5.19531 5.79688 5.19531C5.49484 5.19531 5.25 5.44016 5.25 5.74219C5.25 6.04422 5.49484 6.28906 5.79688 6.28906Z"
      fill="#8181A5"
    />
  </svg>
);
export const DownArrow = () => (
  <svg
    width="10"
    height="6"
    viewBox="0 0 10 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 1L5 5L9 1"
      stroke="#1C1D21"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const ProfileIconPurple = () => (
  <svg
    width="34"
    height="34"
    viewBox="0 0 34 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="34" height="34" rx="6" fill="#F5F4FF" />
    <path
      d="M22.3346 23V21.6667C22.3346 20.9594 22.0537 20.2811 21.5536 19.781C21.0535 19.281 20.3752 19 19.668 19H14.3346C13.6274 19 12.9491 19.281 12.449 19.781C11.9489 20.2811 11.668 20.9594 11.668 21.6667V23"
      stroke="#7D63EC"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.9987 16.3333C18.4715 16.3333 19.6654 15.1394 19.6654 13.6667C19.6654 12.1939 18.4715 11 16.9987 11C15.5259 11 14.332 12.1939 14.332 13.6667C14.332 15.1394 15.5259 16.3333 16.9987 16.3333Z"
      stroke="#7D63EC"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const TickIconPurple = () => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="30" height="30" rx="8" fill="#F5F4FF" />
    <g clipPath="url(#clip0_374_98350)">
      <path
        d="M20.8327 14.4641V15.0007C20.832 16.2586 20.4246 17.4826 19.6715 18.4901C18.9183 19.4976 17.8596 20.2347 16.6533 20.5913C15.447 20.948 14.1578 20.9052 12.9778 20.4692C11.7978 20.0333 10.7904 19.2276 10.1057 18.1724C9.42109 17.1171 9.09589 15.8688 9.17866 14.6136C9.26143 13.3584 9.74772 12.1636 10.565 11.2074C11.3823 10.2511 12.4868 9.58471 13.7138 9.30749C14.9408 9.03027 16.2245 9.1571 17.3735 9.66907"
        stroke="#8B6FFA"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.8333 10.332L15 16.1712L13.25 14.4212"
        stroke="#8B6FFA"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_374_98350">
        <rect width="14" height="14" fill="white" transform="translate(8 8)" />
      </clipPath>
    </defs>
  </svg>
);
export const AlertIconYellow = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.71758 2.89393L1.36508 13.4989C1.2341 13.7257 1.1648 13.9829 1.16407 14.2448C1.16334 14.5067 1.23119 14.7643 1.3609 14.9918C1.4906 15.2194 1.67762 15.409 1.90336 15.5418C2.12909 15.6746 2.38568 15.7461 2.64758 15.7489H15.3526C15.6145 15.7461 15.8711 15.6746 16.0968 15.5418C16.3225 15.409 16.5096 15.2194 16.6393 14.9918C16.769 14.7643 16.8368 14.5067 16.8361 14.2448C16.8354 13.9829 16.7661 13.7257 16.6351 13.4989L10.2826 2.89393C10.1489 2.67351 9.96062 2.49127 9.73597 2.3648C9.51133 2.23832 9.25788 2.17188 9.00008 2.17188C8.74228 2.17188 8.48883 2.23832 8.26418 2.3648C8.03954 2.49127 7.85128 2.67351 7.71758 2.89393Z"
      fill="#F2AE34"
      stroke="#F2AE34"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 6.75V9.75"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 12.75H9.0075"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const NotesIconGreen = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.33268 1.33203H3.99935C3.64573 1.33203 3.30659 1.47251 3.05654 1.72256C2.80649 1.9726 2.66602 2.31174 2.66602 2.66536V13.332C2.66602 13.6857 2.80649 14.0248 3.05654 14.2748C3.30659 14.5249 3.64573 14.6654 3.99935 14.6654H11.9993C12.353 14.6654 12.6921 14.5249 12.9422 14.2748C13.1922 14.0248 13.3327 13.6857 13.3327 13.332V5.33203L9.33268 1.33203Z"
      fill="#005A5A"
      stroke="#005A5A"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.33398 1.33203V5.33203H13.334"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.6673 8.66797H5.33398"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.6673 11.332H5.33398"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.66732 6H6.00065H5.33398"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const NotesIconGrey = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.33366 1.33203H4.00033C3.6467 1.33203 3.30756 1.47251 3.05752 1.72256C2.80747 1.9726 2.66699 2.31174 2.66699 2.66536V13.332C2.66699 13.6857 2.80747 14.0248 3.05752 14.2748C3.30756 14.5249 3.6467 14.6654 4.00033 14.6654H12.0003C12.3539 14.6654 12.6931 14.5249 12.9431 14.2748C13.1932 14.0248 13.3337 13.6857 13.3337 13.332V5.33203L9.33366 1.33203Z"
      fill="white"
      stroke="#888888"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.33301 1.33203V5.33203H13.333"
      stroke="#888888"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.6663 8.66797H5.33301"
      stroke="#888888"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.6663 11.332H5.33301"
      stroke="#888888"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.66634 6H5.99967H5.33301"
      stroke="#888888"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const BellIconGreen = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 5.33203C12 4.27117 11.5786 3.25375 10.8284 2.5036C10.0783 1.75346 9.06087 1.33203 8 1.33203C6.93913 1.33203 5.92172 1.75346 5.17157 2.5036C4.42143 3.25375 4 4.27117 4 5.33203C4 9.9987 2 11.332 2 11.332H14C14 11.332 12 9.9987 12 5.33203Z"
      fill="#005A5A"
      stroke="#005A5A"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.15335 14C9.03614 14.2021 8.86791 14.3698 8.6655 14.4864C8.46309 14.6029 8.2336 14.6643 8.00001 14.6643C7.76643 14.6643 7.53694 14.6029 7.33453 14.4864C7.13212 14.3698 6.96389 14.2021 6.84668 14"
      stroke="#005A5A"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const BellIconGrey = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 5.33203C12 4.27117 11.5786 3.25375 10.8284 2.5036C10.0783 1.75346 9.06087 1.33203 8 1.33203C6.93913 1.33203 5.92172 1.75346 5.17157 2.5036C4.42143 3.25375 4 4.27117 4 5.33203C4 9.9987 2 11.332 2 11.332H14C14 11.332 12 9.9987 12 5.33203Z"
      fill="white"
      stroke="#888888"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.15237 14C9.03516 14.2021 8.86693 14.3698 8.66452 14.4864C8.46211 14.6029 8.23262 14.6643 7.99904 14.6643C7.76545 14.6643 7.53596 14.6029 7.33355 14.4864C7.13114 14.3698 6.96291 14.2021 6.8457 14"
      stroke="#888888"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const VisitsIconGrey = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.66634 2H13.333C13.6866 2 14.0258 2.14048 14.2758 2.39052C14.5259 2.64057 14.6663 2.97971 14.6663 3.33333V7.33333C14.6663 9.10144 13.964 10.7971 12.7137 12.0474C11.4635 13.2976 9.76779 14 7.99967 14C7.1242 14 6.25729 13.8276 5.44845 13.4925C4.63961 13.1575 3.90469 12.6664 3.28563 12.0474C2.03539 10.7971 1.33301 9.10144 1.33301 7.33333V3.33333C1.33301 2.97971 1.47348 2.64057 1.72353 2.39052C1.97358 2.14048 2.31272 2 2.66634 2Z"
      fill="white"
      stroke="#888888"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.33301 6.66797L7.99967 9.33464L10.6663 6.66797"
      stroke="#888888"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const VisitsIconGreen = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.66659 2H13.3333C13.6869 2 14.026 2.14048 14.2761 2.39052C14.5261 2.64057 14.6666 2.97971 14.6666 3.33333V7.33333C14.6666 9.10144 13.9642 10.7971 12.714 12.0474C11.4637 13.2976 9.76803 14 7.99992 14C7.12444 14 6.25753 13.8276 5.4487 13.4925C4.63986 13.1575 3.90493 12.6664 3.28587 12.0474C2.03563 10.7971 1.33325 9.10144 1.33325 7.33333V3.33333C1.33325 2.97971 1.47373 2.64057 1.72378 2.39052C1.97382 2.14048 2.31296 2 2.66659 2Z"
      fill="#005A5A"
      stroke="#005A5A"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.33325 6.66797L7.99992 9.33464L10.6666 6.66797"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const CalenderIconRed = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.6016 5.74219C10.6016 5.76808 10.5806 5.78906 10.5547 5.78906C10.5288 5.78906 10.5078 5.76808 10.5078 5.74219C10.5078 5.7163 10.5288 5.69531 10.5547 5.69531C10.5806 5.69531 10.6016 5.7163 10.6016 5.74219Z"
      fill="white"
      stroke="#EB5E5E"
    />
    <path
      d="M10.6016 1.09375V1.59375H11.1016H11.8125C12.7425 1.59375 13.5 2.3512 13.5 3.28125V6.39844C13.5 6.42433 13.479 6.44531 13.4531 6.44531C13.4272 6.44531 13.4062 6.42433 13.4062 6.39844V3.28125C13.4062 2.40201 12.6917 1.6875 11.8125 1.6875H11.1016H10.6016V2.1875V2.73438C10.6016 2.76027 10.5806 2.78125 10.5547 2.78125C10.5288 2.78125 10.5078 2.76027 10.5078 2.73438V2.1875V1.6875H10.0078H7.51953H7.01953V2.1875V2.73438C7.01953 2.76027 6.99855 2.78125 6.97266 2.78125C6.94676 2.78125 6.92578 2.76027 6.92578 2.73438V2.1875V1.6875H6.42578H3.96484H3.46484V2.1875V2.73438C3.46484 2.76027 3.44387 2.78125 3.41797 2.78125C3.39207 2.78125 3.37109 2.76027 3.37109 2.73438V2.1875V1.6875H2.87109H2.1875C1.30826 1.6875 0.59375 2.40201 0.59375 3.28125V11.8125C0.59375 12.6917 1.30826 13.4062 2.1875 13.4062H6.37109C6.39699 13.4062 6.41797 13.4272 6.41797 13.4531C6.41797 13.479 6.39699 13.5 6.37109 13.5H2.1875C1.25745 13.5 0.5 12.7425 0.5 11.8125V3.28125C0.5 2.3512 1.25745 1.59375 2.1875 1.59375H2.87109H3.37109V1.09375V0.546875C3.37109 0.520978 3.39207 0.5 3.41797 0.5C3.44387 0.5 3.46484 0.520978 3.46484 0.546875V1.09375V1.59375H3.96484H6.42578H6.92578V1.09375V0.546875C6.92578 0.520978 6.94676 0.5 6.97266 0.5C6.99855 0.5 7.01953 0.520978 7.01953 0.546875V1.09375V1.59375H7.51953H10.0078H10.5078V1.09375V0.546875C10.5078 0.520978 10.5288 0.5 10.5547 0.5C10.5806 0.5 10.6016 0.520978 10.6016 0.546875V1.09375Z"
      fill="#EB5E5E"
      stroke="#EB5E5E"
    />
    <path
      d="M7.88281 10.6914C7.88281 9.14317 9.14317 7.88281 10.6914 7.88281C12.2396 7.88281 13.5 9.14317 13.5 10.6914C13.5 12.2396 12.2396 13.5 10.6914 13.5C9.14317 13.5 7.88281 12.2396 7.88281 10.6914ZM7.97656 10.6914C7.97656 12.1888 9.19401 13.4062 10.6914 13.4062C12.1888 13.4062 13.4062 12.1888 13.4062 10.6914C13.4062 9.19398 12.1888 7.97656 10.6914 7.97656C9.19401 7.97656 7.97656 9.19398 7.97656 10.6914Z"
      fill="#EB5E5E"
      stroke="#EB5E5E"
    />
    <path
      d="M10.7383 10.1445V10.6445H11.2383H11.4844C11.5103 10.6445 11.5312 10.6655 11.5312 10.6914C11.5312 10.7173 11.5103 10.7383 11.4844 10.7383H10.6914C10.6655 10.7383 10.6445 10.7173 10.6445 10.6914V9.57031C10.6445 9.54442 10.6655 9.52344 10.6914 9.52344C10.7173 9.52344 10.7383 9.54442 10.7383 9.57031V10.1445Z"
      fill="#EB5E5E"
      stroke="#EB5E5E"
    />
    <path
      d="M8.17578 6.28906C8.47781 6.28906 8.72266 6.04422 8.72266 5.74219C8.72266 5.44016 8.47781 5.19531 8.17578 5.19531C7.87375 5.19531 7.62891 5.44016 7.62891 5.74219C7.62891 6.04422 7.87375 6.28906 8.17578 6.28906Z"
      fill="#EB5E5E"
    />
    <path
      d="M5.79688 8.66797C6.09891 8.66797 6.34375 8.42312 6.34375 8.12109C6.34375 7.81906 6.09891 7.57422 5.79688 7.57422C5.49484 7.57422 5.25 7.81906 5.25 8.12109C5.25 8.42312 5.49484 8.66797 5.79688 8.66797Z"
      fill="#EB5E5E"
    />
    <path
      d="M3.41797 6.28906C3.72 6.28906 3.96484 6.04422 3.96484 5.74219C3.96484 5.44016 3.72 5.19531 3.41797 5.19531C3.11594 5.19531 2.87109 5.44016 2.87109 5.74219C2.87109 6.04422 3.11594 6.28906 3.41797 6.28906Z"
      fill="#EB5E5E"
    />
    <path
      d="M3.41797 8.66797C3.72 8.66797 3.96484 8.42312 3.96484 8.12109C3.96484 7.81906 3.72 7.57422 3.41797 7.57422C3.11594 7.57422 2.87109 7.81906 2.87109 8.12109C2.87109 8.42312 3.11594 8.66797 3.41797 8.66797Z"
      fill="#EB5E5E"
    />
    <path
      d="M3.41797 11.0469C3.72 11.0469 3.96484 10.802 3.96484 10.5C3.96484 10.198 3.72 9.95312 3.41797 9.95312C3.11594 9.95312 2.87109 10.198 2.87109 10.5C2.87109 10.802 3.11594 11.0469 3.41797 11.0469Z"
      fill="#EB5E5E"
    />
    <path
      d="M5.79688 11.0469C6.09891 11.0469 6.34375 10.802 6.34375 10.5C6.34375 10.198 6.09891 9.95312 5.79688 9.95312C5.49484 9.95312 5.25 10.198 5.25 10.5C5.25 10.802 5.49484 11.0469 5.79688 11.0469Z"
      fill="#EB5E5E"
    />
    <path
      d="M5.79688 6.28906C6.09891 6.28906 6.34375 6.04422 6.34375 5.74219C6.34375 5.44016 6.09891 5.19531 5.79688 5.19531C5.49484 5.19531 5.25 5.44016 5.25 5.74219C5.25 6.04422 5.49484 6.28906 5.79688 6.28906Z"
      fill="#EB5E5E"
    />
  </svg>
);
export const CalenderIconGray = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.6016 5.74219C10.6016 5.76808 10.5806 5.78906 10.5547 5.78906C10.5288 5.78906 10.5078 5.76808 10.5078 5.74219C10.5078 5.7163 10.5288 5.69531 10.5547 5.69531C10.5806 5.69531 10.6016 5.7163 10.6016 5.74219Z"
      fill="white"
      stroke="#888888"
    />
    <path
      d="M10.6016 1.09375V1.59375H11.1016H11.8125C12.7425 1.59375 13.5 2.3512 13.5 3.28125V6.39844C13.5 6.42433 13.479 6.44531 13.4531 6.44531C13.4272 6.44531 13.4062 6.42433 13.4062 6.39844V3.28125C13.4062 2.40201 12.6917 1.6875 11.8125 1.6875H11.1016H10.6016V2.1875V2.73438C10.6016 2.76027 10.5806 2.78125 10.5547 2.78125C10.5288 2.78125 10.5078 2.76027 10.5078 2.73438V2.1875V1.6875H10.0078H7.51953H7.01953V2.1875V2.73438C7.01953 2.76027 6.99855 2.78125 6.97266 2.78125C6.94676 2.78125 6.92578 2.76027 6.92578 2.73438V2.1875V1.6875H6.42578H3.96484H3.46484V2.1875V2.73438C3.46484 2.76027 3.44387 2.78125 3.41797 2.78125C3.39207 2.78125 3.37109 2.76027 3.37109 2.73438V2.1875V1.6875H2.87109H2.1875C1.30826 1.6875 0.59375 2.40201 0.59375 3.28125V11.8125C0.59375 12.6917 1.30826 13.4062 2.1875 13.4062H6.37109C6.39699 13.4062 6.41797 13.4272 6.41797 13.4531C6.41797 13.479 6.39699 13.5 6.37109 13.5H2.1875C1.25745 13.5 0.5 12.7425 0.5 11.8125V3.28125C0.5 2.3512 1.25745 1.59375 2.1875 1.59375H2.87109H3.37109V1.09375V0.546875C3.37109 0.520978 3.39207 0.5 3.41797 0.5C3.44387 0.5 3.46484 0.520978 3.46484 0.546875V1.09375V1.59375H3.96484H6.42578H6.92578V1.09375V0.546875C6.92578 0.520978 6.94676 0.5 6.97266 0.5C6.99855 0.5 7.01953 0.520978 7.01953 0.546875V1.09375V1.59375H7.51953H10.0078H10.5078V1.09375V0.546875C10.5078 0.520978 10.5288 0.5 10.5547 0.5C10.5806 0.5 10.6016 0.520978 10.6016 0.546875V1.09375Z"
      fill="#888888"
      stroke="#888888"
    />
    <path
      d="M7.88281 10.6914C7.88281 9.14317 9.14317 7.88281 10.6914 7.88281C12.2396 7.88281 13.5 9.14317 13.5 10.6914C13.5 12.2396 12.2396 13.5 10.6914 13.5C9.14317 13.5 7.88281 12.2396 7.88281 10.6914ZM7.97656 10.6914C7.97656 12.1888 9.19401 13.4062 10.6914 13.4062C12.1888 13.4062 13.4062 12.1888 13.4062 10.6914C13.4062 9.19398 12.1888 7.97656 10.6914 7.97656C9.19401 7.97656 7.97656 9.19398 7.97656 10.6914Z"
      fill="#888888"
      stroke="#888888"
    />
    <path
      d="M10.7383 10.1445V10.6445H11.2383H11.4844C11.5103 10.6445 11.5312 10.6655 11.5312 10.6914C11.5312 10.7173 11.5103 10.7383 11.4844 10.7383H10.6914C10.6655 10.7383 10.6445 10.7173 10.6445 10.6914V9.57031C10.6445 9.54442 10.6655 9.52344 10.6914 9.52344C10.7173 9.52344 10.7383 9.54442 10.7383 9.57031V10.1445Z"
      fill="#888888"
      stroke="#888888"
    />
    <path
      d="M8.17578 6.28906C8.47781 6.28906 8.72266 6.04422 8.72266 5.74219C8.72266 5.44016 8.47781 5.19531 8.17578 5.19531C7.87375 5.19531 7.62891 5.44016 7.62891 5.74219C7.62891 6.04422 7.87375 6.28906 8.17578 6.28906Z"
      fill="#888888"
    />
    <path
      d="M5.79688 8.66797C6.09891 8.66797 6.34375 8.42312 6.34375 8.12109C6.34375 7.81906 6.09891 7.57422 5.79688 7.57422C5.49484 7.57422 5.25 7.81906 5.25 8.12109C5.25 8.42312 5.49484 8.66797 5.79688 8.66797Z"
      fill="#888888"
    />
    <path
      d="M3.41797 6.28906C3.72 6.28906 3.96484 6.04422 3.96484 5.74219C3.96484 5.44016 3.72 5.19531 3.41797 5.19531C3.11594 5.19531 2.87109 5.44016 2.87109 5.74219C2.87109 6.04422 3.11594 6.28906 3.41797 6.28906Z"
      fill="#888888"
    />
    <path
      d="M3.41797 8.66797C3.72 8.66797 3.96484 8.42312 3.96484 8.12109C3.96484 7.81906 3.72 7.57422 3.41797 7.57422C3.11594 7.57422 2.87109 7.81906 2.87109 8.12109C2.87109 8.42312 3.11594 8.66797 3.41797 8.66797Z"
      fill="#888888"
    />
    <path
      d="M3.41797 11.0469C3.72 11.0469 3.96484 10.802 3.96484 10.5C3.96484 10.198 3.72 9.95312 3.41797 9.95312C3.11594 9.95312 2.87109 10.198 2.87109 10.5C2.87109 10.802 3.11594 11.0469 3.41797 11.0469Z"
      fill="#888888"
    />
    <path
      d="M5.79688 11.0469C6.09891 11.0469 6.34375 10.802 6.34375 10.5C6.34375 10.198 6.09891 9.95312 5.79688 9.95312C5.49484 9.95312 5.25 10.198 5.25 10.5C5.25 10.802 5.49484 11.0469 5.79688 11.0469Z"
      fill="#888888"
    />
    <path
      d="M5.79688 6.28906C6.09891 6.28906 6.34375 6.04422 6.34375 5.74219C6.34375 5.44016 6.09891 5.19531 5.79688 5.19531C5.49484 5.19531 5.25 5.44016 5.25 5.74219C5.25 6.04422 5.49484 6.28906 5.79688 6.28906Z"
      fill="#888888"
    />
  </svg>
);
export const ProfileOutLineIconGrey = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.3327 14V12.6667C13.3327 11.9594 13.0517 11.2811 12.5516 10.781C12.0515 10.281 11.3733 10 10.666 10H5.33268C4.62544 10 3.94716 10.281 3.44706 10.781C2.94697 11.2811 2.66602 11.9594 2.66602 12.6667V14"
      stroke="#8181A5"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.00065 7.33333C9.47341 7.33333 10.6673 6.13943 10.6673 4.66667C10.6673 3.19391 9.47341 2 8.00065 2C6.52789 2 5.33398 3.19391 5.33398 4.66667C5.33398 6.13943 6.52789 7.33333 8.00065 7.33333Z"
      stroke="#8181A5"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const PostCardIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.167 17.5H5.83366C2.50033 17.5 1.66699 16.6667 1.66699 13.3333V6.66667C1.66699 3.33333 2.50033 2.5 5.83366 2.5H14.167C17.5003 2.5 18.3337 3.33333 18.3337 6.66667V13.3333C18.3337 16.6667 17.5003 17.5 14.167 17.5Z"
      stroke="#8181A5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.667 6.66406H15.8337"
      stroke="#8181A5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.5 10H15.8333"
      stroke="#8181A5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.167 13.3359H15.8337"
      stroke="#8181A5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.08353 9.40729C7.91656 9.40729 8.59186 8.73199 8.59186 7.89896C8.59186 7.06593 7.91656 6.39062 7.08353 6.39062C6.2505 6.39062 5.5752 7.06593 5.5752 7.89896C5.5752 8.73199 6.2505 9.40729 7.08353 9.40729Z"
      stroke="#8181A5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.0003 13.6104C9.88366 12.4021 8.92533 11.4521 7.71699 11.3438C7.30033 11.3021 6.87533 11.3021 6.45033 11.3438C5.24199 11.4604 4.28366 12.4021 4.16699 13.6104"
      stroke="#8181A5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const UsersIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.63314 9.05573C7.5498 9.0474 7.4498 9.0474 7.35814 9.05573C5.3748 8.98906 3.7998 7.36406 3.7998 5.36406C3.7998 3.3224 5.4498 1.66406 7.4998 1.66406C9.54147 1.66406 11.1998 3.3224 11.1998 5.36406C11.1915 7.36406 9.61647 8.98906 7.63314 9.05573Z"
      stroke="#433F5C"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.6747 3.33594C15.2914 3.33594 16.5914 4.64427 16.5914 6.2526C16.5914 7.8276 15.3414 9.11094 13.7831 9.16927C13.7164 9.16094 13.6414 9.16094 13.5664 9.16927"
      stroke="#433F5C"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.4666 12.1359C1.44993 13.4859 1.44993 15.6859 3.4666 17.0276C5.75827 18.5609 9.5166 18.5609 11.8083 17.0276C13.8249 15.6776 13.8249 13.4776 11.8083 12.1359C9.52494 10.6109 5.7666 10.6109 3.4666 12.1359Z"
      stroke="#433F5C"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.2832 16.6641C15.8832 16.5391 16.4499 16.2974 16.9165 15.9391C18.2165 14.9641 18.2165 13.3557 16.9165 12.3807C16.4582 12.0307 15.8999 11.7974 15.3082 11.6641"
      stroke="#433F5C"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const SubsIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.0505 8.70139L17.2338 12.1847C16.5338 15.1931 15.1505 16.4097 12.5505 16.1597C12.1338 16.1264 11.6838 16.0514 11.2005 15.9347L9.80048 15.6014C6.32548 14.7764 5.25048 13.0597 6.06714 9.57639L6.88381 6.08472C7.05048 5.37639 7.25048 4.75972 7.50048 4.25139C8.47548 2.23472 10.1338 1.69306 12.9171 2.35139L14.3088 2.67639C17.8005 3.49306 18.8671 5.21806 18.0505 8.70139Z"
      stroke="#8181A5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.5503 16.1583C12.0336 16.5083 11.3836 16.8 10.592 17.0583L9.27528 17.4917C5.96695 18.5583 4.22528 17.6667 3.15028 14.3583L2.08362 11.0667C1.01695 7.75833 1.90028 6.00833 5.20862 4.94167L6.52528 4.50833C6.86695 4.4 7.19195 4.30833 7.50028 4.25C7.25028 4.75833 7.05028 5.375 6.88362 6.08333L6.06695 9.575C5.25028 13.0583 6.32528 14.775 9.80029 15.6L11.2003 15.9333C11.6836 16.05 12.1336 16.125 12.5503 16.1583Z"
      stroke="#8181A5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.5332 7.10938L14.5749 8.13438"
      stroke="#8181A5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.7168 10.3359L12.1335 10.9526"
      stroke="#8181A5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const SupportIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.62835 12.1199H2.56071C2.05846 12.1199 1.57679 11.9132 1.22165 11.5451C0.866504 11.177 0.666992 10.6778 0.666992 10.1572V8.63218C0.666992 8.11163 0.866504 7.61241 1.22165 7.24433C1.57679 6.87624 2.05846 6.66946 2.56071 6.66946H3.22233V6.65259C3.22233 3.3452 5.80924 0.664062 9.00033 0.664062C12.1914 0.664062 14.7783 3.3452 14.7783 6.65259V6.66946H15.4399C15.9422 6.66946 16.4239 6.87624 16.779 7.24433C17.1341 7.61241 17.3337 8.11163 17.3337 8.63218V10.1572C17.3337 10.6778 17.1341 11.177 16.779 11.5451C16.4239 11.9132 15.9422 12.1199 15.4399 12.1199H14.5226C14.435 12.1199 14.351 12.0839 14.2891 12.0197C14.2272 11.9555 14.1924 11.8685 14.1924 11.7777V6.65259C14.1924 3.68063 11.8678 1.27135 9.00033 1.27135C6.13284 1.27135 3.80827 3.68063 3.80827 6.65259V11.7777C3.80827 11.8685 3.7735 11.9555 3.71159 12.0197C3.64964 12.0839 3.56569 12.1199 3.47812 12.1199H3.21432C3.22933 14.041 4.73633 15.5932 6.5931 15.5932H7.15996C7.21575 15.3263 7.34453 15.0791 7.53379 14.883C7.79323 14.6141 8.14512 14.463 8.51204 14.463H9.48861C10.2527 14.463 10.8721 15.105 10.8721 15.8969C10.8721 16.6888 10.2527 17.3307 9.48861 17.3307H8.51204C7.84854 17.3307 7.29411 16.8466 7.15967 16.2005H6.5931C4.41256 16.2005 2.64316 14.3761 2.62835 12.1199ZM10.2861 15.8969C10.2861 15.4403 9.92907 15.0703 9.48861 15.0703H8.51204C8.30052 15.0703 8.09769 15.1573 7.94811 15.3124C7.79853 15.4674 7.71452 15.6776 7.71452 15.8969C7.71452 16.3534 8.07158 16.7234 8.51204 16.7234H9.48861C9.92907 16.7234 10.2861 16.3534 10.2861 15.8969ZM3.22233 7.27675H2.56071C2.21387 7.27675 1.88122 7.41956 1.63597 7.67375C1.39072 7.92793 1.25293 8.2727 1.25293 8.63218V10.1572C1.25293 10.5167 1.39072 10.8615 1.63597 11.1156C1.88122 11.3698 2.21387 11.5126 2.56071 11.5126H3.22233V7.27675ZM14.7783 7.27675V11.5126H15.4399C15.7868 11.5126 16.1194 11.3698 16.3647 11.1156C16.61 10.8615 16.7477 10.5167 16.7477 10.1572V8.63218C16.7477 8.2727 16.61 7.92793 16.3647 7.67375C16.1194 7.41956 15.7868 7.27675 15.4399 7.27675H14.7783Z"
      fill="#8181A5"
      stroke="#8181A5"
      strokeWidth="0.5"
    />
  </svg>
);
export const LegPieceIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.1457 6.55539C18.8335 5.16174 18.1316 3.88557 17.1217 2.87569C16.1118 1.86581 14.8356 1.16384 13.442 0.851641C12.4539 0.632891 11.5076 0.632891 10.6295 0.851016C7.06761 1.73539 4.58824 6.09352 4.73386 11.2129C4.74512 11.6145 4.81438 12.0124 4.93949 12.3941L3.90699 13.431C3.48999 13.2225 3.01784 13.1509 2.55776 13.2263C2.09768 13.3017 1.67311 13.5203 1.34449 13.851C0.480736 14.7148 0.466986 16.106 1.31324 16.9523C1.62574 17.2648 2.02136 17.4704 2.44761 17.5491C2.52698 17.979 2.73514 18.3746 3.04449 18.6835C3.24449 18.883 3.48197 19.041 3.74326 19.1484C4.00455 19.2557 4.2845 19.3104 4.56699 19.3091C4.86051 19.3089 5.1511 19.2508 5.42212 19.1381C5.69314 19.0253 5.93925 18.8603 6.14636 18.6523C6.47732 18.3238 6.69611 17.8992 6.77153 17.4391C6.84695 16.9789 6.77515 16.5067 6.56636 16.0898L7.60324 15.0573C7.98502 15.1824 8.38289 15.2516 8.78449 15.2629C8.92761 15.2673 9.06949 15.2691 9.21136 15.2691C14.1451 15.2691 18.2876 12.8298 19.1476 9.36789C19.3651 8.48977 19.3651 7.54352 19.1457 6.55539ZM5.44511 15.6191C5.34371 15.7203 5.28468 15.8563 5.28004 15.9995C5.27539 16.1427 5.32548 16.2822 5.42011 16.3898C5.78761 16.8066 5.75699 17.451 5.35074 17.8579C4.92511 18.2829 4.24824 18.2966 3.84011 17.8891C3.73307 17.7819 3.65081 17.6525 3.59909 17.5101C3.54737 17.3677 3.52745 17.2157 3.54074 17.0648C3.54747 16.9833 3.53637 16.9014 3.50821 16.8246C3.48005 16.7479 3.43551 16.6782 3.37769 16.6205C3.31987 16.5627 3.25015 16.5182 3.17339 16.4902C3.09664 16.4621 3.01468 16.4511 2.93324 16.4579C2.78233 16.4708 2.63043 16.4507 2.48808 16.399C2.34572 16.3473 2.21632 16.2652 2.10886 16.1585C1.70136 15.7504 1.71511 15.0729 2.14011 14.6479C2.54699 14.2423 3.19136 14.2116 3.60824 14.5785C3.71577 14.6731 3.85533 14.7232 3.9985 14.7186C4.14167 14.7139 4.27768 14.6549 4.37886 14.5535L5.46824 13.4598C5.75736 13.8789 6.12036 14.2419 6.53949 14.531L5.44511 15.6191ZM18.0551 9.09727C17.4051 11.7148 14.0245 14.286 8.81574 14.1398C8.03835 14.1171 7.29902 13.7982 6.7491 13.2483C6.19917 12.6984 5.88025 11.959 5.85761 11.1816C5.71011 5.97477 8.28261 2.59289 10.9001 1.94227C11.6076 1.76602 12.3807 1.76914 13.1982 1.94977C14.3831 2.21518 15.468 2.81201 16.3265 3.67063C17.185 4.52925 17.7817 5.61428 18.047 6.79914C18.2289 7.61539 18.2314 8.38852 18.0551 9.09727Z"
      fill="#7A7C89"
    />
  </svg>
);
export const GlassIcon = () => (
  <svg
    width="11"
    height="20"
    viewBox="0 0 11 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.27482 0.101072C2.18959 0.156461 2.09369 0.270992 2.06164 0.355603C2.02958 0.440161 1.76387 1.43834 1.47113 2.57373C1.17839 3.70912 0.871318 4.87936 0.78875 5.17426C0.415811 6.50638 0.402276 7.68257 0.744825 8.98354C1.25367 10.916 2.74799 12.5098 4.41726 12.9005C4.62481 12.9491 4.82296 12.9972 4.85752 13.0075C4.90633 13.0219 4.92042 13.4508 4.92042 14.9208V16.8154L3.37321 17.5076C1.68165 18.2643 1.51033 18.3772 1.40215 18.8053C1.33608 19.0668 1.39254 19.4099 1.53624 19.6204C1.58816 19.6965 1.73036 19.813 1.85217 19.8794L2.07376 20H5.55676C7.89533 20 9.0863 19.9813 9.1814 19.9429C9.35494 19.8731 9.58443 19.6475 9.67972 19.4531C9.7637 19.2818 9.77256 18.8889 9.69718 18.6764C9.57985 18.3454 9.43197 18.2589 7.73301 17.5281L6.07768 16.816V14.9211C6.07768 13.4499 6.09177 13.0224 6.14057 13.0092C6.17519 12.9999 6.40725 12.9399 6.65631 12.8758C8.14575 12.4926 9.47323 11.1776 10.0996 9.46472C10.6047 8.08375 10.629 6.6985 10.1759 5.12064C10.0742 4.76676 9.73427 3.53619 9.4203 2.38606C8.90164 0.485952 8.83543 0.281448 8.69555 0.147453L8.54153 0L5.48566 0.000214462C2.58472 0.00037532 2.42195 0.0055228 2.27482 0.101072ZM2.98352 1.24665C2.93124 1.40772 1.96991 5.13308 1.81786 5.76375C1.63129 6.5378 1.60235 6.93957 1.7295 6.99158C1.77328 7.00949 1.99004 7.02413 2.21117 7.02413C2.75227 7.02413 3.14961 6.87764 4.34179 6.23861C6.37087 5.15099 7.30865 4.87029 8.51703 4.98895C8.76554 5.01335 8.97193 5.02885 8.97561 5.02338C8.97928 5.01791 8.76997 4.24129 8.51044 3.29759C8.25091 2.35389 8.01538 1.49131 7.987 1.3807L7.93548 1.17962H5.47037C3.54343 1.17962 3.00053 1.19426 2.98352 1.24665ZM7.51167 6.1963C7.45633 6.20981 7.28651 6.24729 7.13431 6.27957C6.74335 6.36247 5.96447 6.71217 4.78104 7.33614C3.37306 8.07861 2.63715 8.31453 1.96146 8.24021L1.69368 8.21078L1.72845 8.38155C1.8892 9.17094 2.27704 9.92831 2.85058 10.5727C3.33633 11.1185 3.80648 11.4532 4.3921 11.6702C4.75805 11.8058 4.85863 11.8194 5.49905 11.8194C6.13947 11.8194 6.24005 11.8058 6.60599 11.6702C7.17607 11.459 7.65643 11.1209 8.12447 10.6013C8.97898 9.65276 9.35866 8.59796 9.36741 7.14836C9.36978 6.75957 9.35569 6.42445 9.33617 6.40359C9.2058 6.26472 7.85845 6.11164 7.51167 6.1963ZM4.41907 18.3287L3.38946 18.7936L4.48539 18.808C5.08817 18.816 6.05765 18.816 6.63986 18.808L7.69839 18.7936L6.61294 18.3244C6.01594 18.0664 5.50977 17.8572 5.48808 17.8595C5.46644 17.8619 4.98538 18.073 4.41907 18.3287Z"
      fill="#7A7C89"
    />
  </svg>
);
export const MoneyIcon = () => (
  <svg
    width="13"
    height="10"
    viewBox="0 0 13 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.7001 7.8474e-08L0.433333 7.84785e-08C0.318406 7.84785e-08 0.208186 0.0478897 0.126921 0.133133C0.0456549 0.218377 0 0.333993 0 0.454545C0 0.575098 0.0456549 0.690714 0.126921 0.775958C0.208186 0.861201 0.318406 0.909091 0.433333 0.909091H10.0027C10.0932 1.46732 10.3469 1.98225 10.7286 2.38265C11.1103 2.78305 11.6012 3.04913 12.1334 3.14409V6.85591C11.6012 6.95087 11.1103 7.21695 10.7286 7.61735C10.3469 8.01775 10.0932 8.53268 10.0027 9.09091H2.99743C2.9069 8.53268 2.65324 8.01775 2.27152 7.61735C1.88981 7.21695 1.39891 6.95087 0.866732 6.85591V1.36364C0.866732 1.24308 0.821077 1.12747 0.739811 1.04222C0.658545 0.956981 0.548261 0.909091 0.433333 0.909091C0.318406 0.909091 0.208251 0.956981 0.126986 1.04222C0.0457198 1.12747 6.48499e-05 1.24308 6.48499e-05 1.36364V8.63636C6.48499e-05 8.99802 0.137029 9.34487 0.380826 9.6006C0.624623 9.85633 0.955284 10 1.30007 10H11.7001C12.045 10 12.3756 9.85636 12.6192 9.60046C12.74 9.47392 12.8358 9.32363 12.9011 9.1582C12.9665 8.99277 13.0001 8.81544 13.0001 8.63636V1.36364C13.0001 1.00182 12.8631 0.655 12.6192 0.399546C12.4985 0.272831 12.3553 0.172317 12.1975 0.103757C12.0398 0.0351978 11.8708 -6.07119e-05 11.7001 7.8474e-08ZM12.1334 7.78455C11.8337 7.86615 11.5602 8.03028 11.3412 8.25995C11.1223 8.48963 10.9658 8.77651 10.888 9.09091H11.7001C11.757 9.09109 11.8134 9.07946 11.8661 9.05668C11.9187 9.0339 11.9666 9.00042 12.0069 8.95818C12.0471 8.91593 12.079 8.86575 12.1008 8.81052C12.1225 8.75529 12.1336 8.69611 12.1334 8.63636V7.78455ZM0.866732 7.78455V8.63636C0.866732 8.75692 0.912387 8.87253 0.993652 8.95778C1.07492 9.04302 1.18514 9.09091 1.30007 9.09091H2.11213C2.03434 8.77651 1.87787 8.48963 1.65891 8.25995C1.43995 8.03028 1.16646 7.86615 0.866732 7.78455ZM10.888 0.909091C10.9658 1.22349 11.1223 1.51037 11.3412 1.74005C11.5602 1.96972 11.8337 2.13385 12.1334 2.21545V1.36364C12.1336 1.30389 12.1225 1.24471 12.1008 1.18948C12.079 1.13425 12.0471 1.08407 12.0069 1.04182C11.9666 0.999578 11.9187 0.966104 11.8661 0.943324C11.8134 0.920545 11.757 0.908911 11.7001 0.909091H10.888Z"
      fill="#5D5E62"
    />
    <path
      d="M8.38454 2.92118H6.843C7.02136 3.02809 7.15867 3.15727 7.25493 3.30873C7.35119 3.45721 7.41489 3.625 7.44603 3.81209H8.38454V4.49364H7.43754C7.37808 4.80248 7.23795 5.07273 7.01712 5.30436C6.79912 5.536 6.51035 5.70676 6.1508 5.81664C6.28669 5.89088 6.40135 6.00076 6.49478 6.14627L8.21043 8.63636H7.40356C7.24502 8.63636 7.12612 8.56955 7.04685 8.43591L5.54352 6.21755C5.4954 6.1433 5.44302 6.09133 5.3864 6.06164C5.32978 6.02897 5.24343 6.01264 5.12735 6.01264H4.39268V5.35782H5.20379C5.58316 5.35782 5.88609 5.27912 6.11258 5.12173C6.3419 4.96136 6.49336 4.752 6.56697 4.49364H4.38418V3.81209H6.58821C6.52875 3.53591 6.38578 3.32358 6.15929 3.17509C5.93563 3.02364 5.62704 2.94791 5.23352 2.94791H4.39268V2.23964H8.38454V2.92118Z"
      fill="#5D5E62"
    />
  </svg>
);
export const LeavesIcon = () => (
  <svg
    width="20"
    height="14"
    viewBox="0 0 20 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.9729 5.03273C19.9594 4.8917 19.8972 4.75976 19.7971 4.65958C19.6969 4.5594 19.5649 4.49723 19.4239 4.48375C19.2609 4.4682 15.4064 4.12812 13.1618 6.37273C12.6751 6.85945 12.3101 7.42187 12.0368 8.00589C11.5866 6.16277 10.786 4.63359 9.68684 3.53445C8.33212 2.17972 6.32422 1.27839 3.88032 0.927965C2.06188 0.667183 0.645904 0.797457 0.586529 0.803199C0.445495 0.816679 0.313556 0.878848 0.213375 0.979029C0.113194 1.07921 0.0510244 1.21115 0.0375448 1.35218C0.0318417 1.41156 -0.0984318 2.8275 0.16231 4.64597C0.51274 7.08988 1.41403 9.09781 2.76879 10.4525C4.12352 11.8072 6.13141 12.7086 8.57532 13.059C9.47536 13.188 10.2766 13.2213 10.8637 13.2213C11.3957 13.2212 12.1711 13.2109 12.5281 13.2109C13.7764 13.2109 16.3891 12.9896 18.0839 11.2948C20.3285 9.05027 19.9885 5.19578 19.9729 5.03273ZM6.65895 6.56234C6.42087 6.32425 6.03477 6.32425 5.79661 6.56234C5.55848 6.80043 5.55848 7.18652 5.79661 7.42468L10.3639 11.9919C8.60403 11.9327 5.56817 11.5273 3.6311 9.59023C1.32258 7.28171 1.19172 3.39246 1.22606 1.99101C2.62754 1.95445 6.51032 2.08261 8.82454 4.39683C10.756 6.32832 11.163 9.36601 11.2243 11.1277L6.65895 6.56234ZM17.2216 10.4325C16.1468 11.5073 14.5296 11.8514 13.3675 11.9514L16.054 9.26492C16.2922 9.02683 16.2922 8.64074 16.054 8.40257C15.8159 8.16449 15.4299 8.16449 15.1917 8.40257L12.5028 11.0914C12.6014 9.93085 12.9444 8.31472 14.0241 7.23503C15.423 5.83613 17.7402 5.67472 18.7779 5.67867C18.7816 6.7164 18.6202 9.03382 17.2216 10.4325Z"
      fill="#7A7C89"
    />
  </svg>
);
export const JuiceGlassIcon = () => (
  <svg
    width="18"
    height="20"
    viewBox="0 0 18 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.0494 3.52656H10.0963L10.0993 3.47969C10.219 1.56843 11.8118 0.05 13.7527 0.05C15.7713 0.05 17.4136 1.69234 17.4136 3.71094C17.4136 6.28434 14.8115 8.06376 12.4085 7.11606L12.371 7.10125L12.3486 7.13484L8.04704 13.5871L8.03864 13.5997V13.6149V16.2873V16.3108L8.05672 16.3257L11.2824 19.0016C11.3672 19.072 11.4283 19.1668 11.4573 19.2732C11.4863 19.3796 11.4818 19.4923 11.4443 19.596C11.4069 19.6997 11.3384 19.7893 11.2482 19.8527C11.158 19.916 11.0504 19.95 10.9402 19.95H4.0652C3.95496 19.95 3.84739 19.916 3.75717 19.8527C3.66696 19.7893 3.59847 19.6997 3.56106 19.596C3.52364 19.4923 3.51912 19.3796 3.54811 19.2732C3.57709 19.1668 3.63817 19.072 3.72302 19.0016L6.94869 16.3257L6.96676 16.3108V16.2873V13.6149V13.5997L6.95837 13.5871L0.806804 4.35977L0.806802 4.35976C0.569504 4.00387 0.825691 3.52656 1.2527 3.52656H5.41575H5.48677L5.46282 3.4597L4.63723 1.15501L4.62536 1.12187H4.59016H1.2527C0.956722 1.12187 0.716764 0.881917 0.716764 0.585938C0.716764 0.289958 0.956722 0.05 1.2527 0.05H5.0027C5.11314 0.049998 5.22089 0.0841205 5.31119 0.147699C5.4015 0.211277 5.46995 0.301205 5.50719 0.405179L5.55317 0.388712L5.50719 0.405182L6.61344 3.49342L6.62531 3.52656H6.66051H10.0494ZM12.6995 4.67617L12.7513 4.59844H12.6579H7.08028H7.00926L7.03321 4.6653L7.6577 6.40858L7.66714 6.43492L7.69453 6.44066C8.3635 6.58073 9.04515 6.6514 9.72863 6.65156H11.3558H11.3825L11.3974 6.6293L12.6995 4.67617ZM7.4611 12.4089L7.5027 12.4713L7.5443 12.4089L10.6161 7.80121L10.668 7.72348H10.5745C10.4666 7.72348 10.3635 7.72374 10.264 7.72399C9.51285 7.72589 8.97263 7.72725 8.1666 7.61168L8.08444 7.5999L8.11243 7.67803L8.31973 8.25678C8.41956 8.53544 8.27461 8.84224 7.99596 8.94207C7.71646 9.04214 7.41015 8.89602 7.31067 8.61826L7.26921 8.63311L7.31067 8.61826L6.8643 7.37212L6.85503 7.34623L6.82819 7.3402C5.73961 7.09572 5.00912 7.09691 4.19626 7.09824C4.13608 7.09834 4.07545 7.09844 4.01419 7.09844H3.92076L3.97258 7.17617L7.4611 12.4089ZM5.88259 4.63158L5.87072 4.59844H5.83551H2.34747H2.25404L2.30586 4.67617L3.19129 6.0043L3.20614 6.02656H3.2329C3.44378 6.02656 3.63767 6.02587 3.81839 6.02522C4.85524 6.02151 5.45863 6.01934 6.35111 6.15881L6.4343 6.17181L6.40591 6.09255L5.88259 4.63158ZM5.65734 18.7896L5.55068 18.8781H5.68926H9.3161H9.45469L9.34802 18.7896L7.53463 17.2853L7.5027 17.2588L7.47078 17.2853L5.65734 18.7896ZM13.0207 6.12656L12.9826 6.18377L13.0488 6.20242C14.7082 6.67011 16.3418 5.41597 16.3418 3.71094C16.3418 2.28328 15.1804 1.12187 13.7527 1.12187C12.4057 1.12187 11.2962 2.15598 11.1751 3.47198L11.1701 3.52656H11.2249H13.7527C14.1804 3.52656 14.4355 4.00446 14.1986 4.35976L13.0207 6.12656Z"
      fill="#7A7C89"
      stroke="white"
      strokeWidth="0.1"
    />
  </svg>
);
export const AlertIconGrey = () => (
  <svg
    width="16"
    height="15"
    viewBox="0 0 16 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.74892 11.7515C8.74892 11.6531 8.72954 11.5557 8.69189 11.4648C8.65423 11.3739 8.59904 11.2913 8.52947 11.2217C8.45989 11.1521 8.3773 11.0969 8.2864 11.0593C8.19549 11.0216 8.09806 11.0022 7.99967 11.0022C7.90128 11.0022 7.80385 11.0216 7.71294 11.0593C7.62204 11.0969 7.53944 11.1521 7.46987 11.2217C7.4003 11.2913 7.34511 11.3739 7.30745 11.4648C7.2698 11.5557 7.25042 11.6531 7.25042 11.7515C7.25658 11.946 7.33817 12.1305 7.47794 12.2659C7.61771 12.4013 7.80468 12.477 7.99929 12.477C8.1939 12.477 8.38088 12.4013 8.52065 12.2659C8.66042 12.1305 8.74201 11.946 8.74817 11.7515H8.74892ZM8.55392 5.86175C8.53448 5.7205 8.46213 5.5919 8.3515 5.50195C8.24086 5.41201 8.1002 5.36744 7.95796 5.37725C7.81571 5.38707 7.6825 5.45053 7.58526 5.55482C7.48803 5.6591 7.43402 5.79642 7.43417 5.939L7.43717 9.31475L7.44242 9.39125C7.46185 9.5325 7.5342 9.6611 7.64484 9.75105C7.75548 9.84099 7.89614 9.88556 8.03838 9.87575C8.18063 9.86593 8.31384 9.80247 8.41107 9.69818C8.50831 9.5939 8.56232 9.45658 8.56217 9.314L8.55917 5.9375L8.55392 5.86175ZM9.47642 1.74575C8.83367 0.58475 7.16492 0.58475 6.52292 1.74575L0.713419 12.2465C0.0909195 13.3715 0.904669 14.7515 2.19092 14.7515H13.8084C15.0939 14.7515 15.9077 13.3715 15.2852 12.2465L9.47567 1.7465L9.47642 1.74575ZM7.50692 2.29025C7.55553 2.20224 7.62685 2.12887 7.71345 2.07777C7.80004 2.02668 7.89875 1.99973 7.99929 1.99973C8.09984 1.99973 8.19855 2.02668 8.28514 2.07777C8.37174 2.12887 8.44305 2.20224 8.49167 2.29025L14.3004 12.7917C14.3478 12.8774 14.372 12.9739 14.3706 13.0717C14.3693 13.1695 14.3425 13.2653 14.2928 13.3496C14.2431 13.4339 14.1723 13.5038 14.0873 13.5523C14.0024 13.6009 13.9063 13.6265 13.8084 13.6265H2.19092C2.09301 13.6266 1.99678 13.6011 1.91173 13.5526C1.82668 13.5041 1.75576 13.4343 1.70599 13.3499C1.65622 13.2656 1.62932 13.1698 1.62795 13.0719C1.62658 12.974 1.65078 12.8774 1.69817 12.7917L7.50692 2.29025Z"
      fill="#8181A5"
    />
  </svg>
);
export const AlertIconOutlineRed = () => (
  <svg
    width="16"
    height="15"
    viewBox="0 0 16 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.74892 11.7515C8.74892 11.6531 8.72954 11.5557 8.69189 11.4648C8.65423 11.3739 8.59904 11.2913 8.52947 11.2217C8.45989 11.1521 8.3773 11.0969 8.2864 11.0593C8.19549 11.0216 8.09806 11.0022 7.99967 11.0022C7.90128 11.0022 7.80385 11.0216 7.71294 11.0593C7.62204 11.0969 7.53944 11.1521 7.46987 11.2217C7.4003 11.2913 7.34511 11.3739 7.30745 11.4648C7.2698 11.5557 7.25042 11.6531 7.25042 11.7515C7.25658 11.946 7.33817 12.1305 7.47794 12.2659C7.61771 12.4013 7.80468 12.477 7.99929 12.477C8.1939 12.477 8.38088 12.4013 8.52065 12.2659C8.66042 12.1305 8.74201 11.946 8.74817 11.7515H8.74892ZM8.55392 5.86175C8.53448 5.7205 8.46213 5.5919 8.3515 5.50195C8.24086 5.41201 8.1002 5.36744 7.95796 5.37725C7.81571 5.38707 7.6825 5.45053 7.58526 5.55482C7.48803 5.6591 7.43402 5.79642 7.43417 5.939L7.43717 9.31475L7.44242 9.39125C7.46185 9.5325 7.5342 9.6611 7.64484 9.75105C7.75548 9.84099 7.89614 9.88556 8.03838 9.87575C8.18063 9.86593 8.31384 9.80247 8.41107 9.69818C8.50831 9.5939 8.56232 9.45658 8.56217 9.314L8.55917 5.9375L8.55392 5.86175ZM9.47642 1.74575C8.83367 0.58475 7.16492 0.58475 6.52292 1.74575L0.713419 12.2465C0.0909195 13.3715 0.904669 14.7515 2.19092 14.7515H13.8084C15.0939 14.7515 15.9077 13.3715 15.2852 12.2465L9.47567 1.7465L9.47642 1.74575ZM7.50692 2.29025C7.55553 2.20224 7.62685 2.12887 7.71345 2.07777C7.80004 2.02668 7.89875 1.99973 7.99929 1.99973C8.09984 1.99973 8.19855 2.02668 8.28514 2.07777C8.37174 2.12887 8.44305 2.20224 8.49167 2.29025L14.3004 12.7917C14.3478 12.8774 14.372 12.9739 14.3706 13.0717C14.3693 13.1695 14.3425 13.2653 14.2928 13.3496C14.2431 13.4339 14.1723 13.5038 14.0873 13.5523C14.0024 13.6009 13.9063 13.6265 13.8084 13.6265H2.19092C2.09301 13.6266 1.99678 13.6011 1.91173 13.5526C1.82668 13.5041 1.75576 13.4343 1.70599 13.3499C1.65622 13.2656 1.62932 13.1698 1.62795 13.0719C1.62658 12.974 1.65078 12.8774 1.69817 12.7917L7.50692 2.29025Z"
      fill="#EB5E5E"
    />
  </svg>
);
export const EditPenIconPurple = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 13.3359H14"
      stroke="#7D63EC"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11 2.33609C11.2652 2.07087 11.6249 1.92188 12 1.92188C12.1857 1.92188 12.3696 1.95845 12.5412 2.02953C12.7128 2.1006 12.8687 2.20477 13 2.33609C13.1313 2.46741 13.2355 2.62331 13.3066 2.79489C13.3776 2.96647 13.4142 3.15037 13.4142 3.33609C13.4142 3.52181 13.3776 3.7057 13.3066 3.87728C13.2355 4.04887 13.1313 4.20477 13 4.33609L4.66667 12.6694L2 13.3361L2.66667 10.6694L11 2.33609Z"
      stroke="#7D63EC"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const EditPenIconGray = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 13.3359H14"
      stroke="#8181A5"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11 2.33609C11.2652 2.07087 11.6249 1.92188 12 1.92188C12.1857 1.92188 12.3696 1.95845 12.5412 2.02953C12.7128 2.1006 12.8687 2.20477 13 2.33609C13.1313 2.46741 13.2355 2.62331 13.3066 2.79489C13.3776 2.96647 13.4142 3.15037 13.4142 3.33609C13.4142 3.52181 13.3776 3.7057 13.3066 3.87728C13.2355 4.04887 13.1313 4.20477 13 4.33609L4.66667 12.6694L2 13.3361L2.66667 10.6694L11 2.33609Z"
      stroke="#8181A5"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const CrowdIcon = () => (
  <svg
    width="16"
    height="12"
    viewBox="0 0 16 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.1166 6.34515H11.7001C11.5073 6.34515 11.3206 6.37149 11.143 6.41993C10.7926 5.73111 10.0772 5.25781 9.25287 5.25781H6.74905C5.9247 5.25781 5.20931 5.73111 4.8589 6.41993C4.67737 6.37032 4.49003 6.34517 4.30184 6.34515H2.88535C1.71653 6.34515 0.765625 7.29606 0.765625 8.46487V10.7292C0.765625 11.4305 1.33617 12.0011 2.03746 12.0011H13.9645C14.6657 12.0011 15.2363 11.4305 15.2363 10.7292V8.46487C15.2363 7.29606 14.2854 6.34515 13.1166 6.34515ZM4.62932 7.3776V11.1532H2.03746C1.8037 11.1532 1.61352 10.963 1.61352 10.7293V8.4649C1.61352 7.76361 2.18406 7.19307 2.88535 7.19307H4.30184C4.41692 7.19307 4.52836 7.2087 4.63446 7.2375C4.63121 7.28413 4.6295 7.33085 4.62932 7.3776ZM10.5247 11.1532H5.47721V7.37757C5.47721 6.67628 6.04776 6.10573 6.74905 6.10573H9.25287C9.95416 6.10573 10.5247 6.67628 10.5247 7.37757V11.1532ZM14.3884 10.7293C14.3884 10.963 14.1982 11.1532 13.9645 11.1532H11.3726V7.37757C11.3724 7.33082 11.3707 7.2841 11.3674 7.23747C11.4759 7.208 11.5877 7.19306 11.7001 7.19304H13.1166C13.8179 7.19304 14.3884 7.76358 14.3884 8.46487V10.7293Z"
      fill="#85868A"
    />
    <path
      d="M3.5926 2.33947C2.55396 2.33947 1.70898 3.18445 1.70898 4.22309C1.70896 5.26172 2.55396 6.1067 3.5926 6.1067C4.63121 6.1067 5.47622 5.26172 5.47622 4.22309C5.47622 3.18445 4.63124 2.33947 3.5926 2.33947ZM3.59257 5.25881C3.02146 5.25881 2.55685 4.7942 2.55685 4.22309C2.55685 3.65198 3.02146 3.18736 3.59257 3.18736C4.16368 3.18736 4.6283 3.65198 4.6283 4.22309C4.6283 4.7942 4.16368 5.25881 3.59257 5.25881ZM7.99994 0C6.61233 0 5.48345 1.12888 5.48345 2.51648C5.48345 3.90408 6.61233 5.03296 7.99994 5.03296C9.38754 5.03296 10.5164 3.90408 10.5164 2.51648C10.5164 1.12891 9.38754 0 7.99994 0ZM7.99994 4.18507C7.07986 4.18507 6.33134 3.43656 6.33134 2.51648C6.33134 1.59644 7.07986 0.84789 7.99994 0.84789C8.92001 0.84789 9.66853 1.59641 9.66853 2.51648C9.66853 3.43656 8.92001 4.18507 7.99994 4.18507ZM12.4073 2.33947C11.3687 2.33947 10.5237 3.18445 10.5237 4.22309C10.5237 5.26172 11.3687 6.1067 12.4073 6.1067C13.4459 6.1067 14.2909 5.26172 14.2909 4.22309C14.2909 3.18445 13.4459 2.33947 12.4073 2.33947ZM12.4073 5.25881C11.8362 5.25881 11.3715 4.7942 11.3715 4.22309C11.3716 3.65198 11.8362 3.18736 12.4073 3.18736C12.9784 3.18736 13.443 3.65198 13.443 4.22309C13.443 4.7942 12.9784 5.25881 12.4073 5.25881Z"
      fill="#85868A"
    />
  </svg>
);
export const AlertIconCircleRed = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
      stroke="#EB5E5E"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 16V12"
      stroke="#EB5E5E"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 8H12.01"
      stroke="#EB5E5E"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const TickIconWhite = () => (
  <svg
    width="11"
    height="8"
    viewBox="0 0 11 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.6437 7.84288L0.157101 4.35628C-0.0523671 4.14681 -0.0523671 3.80718 0.157101 3.59769L0.915668 2.8391C1.12514 2.62961 1.46479 2.62961 1.67426 2.8391L4.023 5.18782L9.05374 0.157101C9.26321 -0.0523671 9.60286 -0.0523671 9.81233 0.157101L10.5709 0.915689C10.7804 1.12516 10.7804 1.46479 10.5709 1.67428L4.40229 7.8429C4.1928 8.05237 3.85317 8.05237 3.6437 7.84288Z"
      fill="white"
    />
  </svg>
);
export const CalenderIconSmall = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.0833 2.33594H2.91667C2.27233 2.33594 1.75 2.85827 1.75 3.5026V11.6693C1.75 12.3136 2.27233 12.8359 2.91667 12.8359H11.0833C11.7277 12.8359 12.25 12.3136 12.25 11.6693V3.5026C12.25 2.85827 11.7277 2.33594 11.0833 2.33594Z"
      fill="white"
      stroke="#58596B"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.33398 1.16406V3.4974"
      stroke="#58596B"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.66602 1.16406V3.4974"
      stroke="#58596B"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.75 5.83594H12.25"
      stroke="#58596B"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const ClockIconSmall = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_9186_490613)">
      <path
        d="M6.99935 12.8307C10.221 12.8307 12.8327 10.2191 12.8327 6.9974C12.8327 3.77573 10.221 1.16406 6.99935 1.16406C3.77769 1.16406 1.16602 3.77573 1.16602 6.9974C1.16602 10.2191 3.77769 12.8307 6.99935 12.8307Z"
        fill="white"
        stroke="#58596B"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 3.5V7L9.33333 8.16667"
        stroke="#58596B"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_9186_490613">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export const CalenderIconDarkGrey = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.5703 8.08594C13.9586 8.08594 14.2734 7.77114 14.2734 7.38281C14.2734 6.99449 13.9586 6.67969 13.5703 6.67969C13.182 6.67969 12.8672 6.99449 12.8672 7.38281C12.8672 7.77114 13.182 8.08594 13.5703 8.08594Z"
      fill="#8181A5"
    />
    <path
      d="M15.1875 1.40625H14.2734V0.703125C14.2734 0.314789 13.9586 0 13.5703 0C13.182 0 12.8672 0.314789 12.8672 0.703125V1.40625H9.66797V0.703125C9.66797 0.314789 9.35318 0 8.96484 0C8.57651 0 8.26172 0.314789 8.26172 0.703125V1.40625H5.09766V0.703125C5.09766 0.314789 4.78287 0 4.39453 0C4.0062 0 3.69141 0.314789 3.69141 0.703125V1.40625H2.8125C1.26169 1.40625 0 2.66794 0 4.21875V15.1875C0 16.7383 1.26169 18 2.8125 18H8.19141C8.57974 18 8.89453 17.6852 8.89453 17.2969C8.89453 16.9085 8.57974 16.5938 8.19141 16.5938H2.8125C2.03709 16.5938 1.40625 15.9629 1.40625 15.1875V4.21875C1.40625 3.44334 2.03709 2.8125 2.8125 2.8125H3.69141V3.51562C3.69141 3.90396 4.0062 4.21875 4.39453 4.21875C4.78287 4.21875 5.09766 3.90396 5.09766 3.51562V2.8125H8.26172V3.51562C8.26172 3.90396 8.57651 4.21875 8.96484 4.21875C9.35318 4.21875 9.66797 3.90396 9.66797 3.51562V2.8125H12.8672V3.51562C12.8672 3.90396 13.182 4.21875 13.5703 4.21875C13.9586 4.21875 14.2734 3.90396 14.2734 3.51562V2.8125H15.1875C15.9629 2.8125 16.5938 3.44334 16.5938 4.21875V8.22656C16.5938 8.6149 16.9085 8.92969 17.2969 8.92969C17.6852 8.92969 18 8.6149 18 8.22656V4.21875C18 2.66794 16.7383 1.40625 15.1875 1.40625Z"
      fill="#8181A5"
    />
    <path
      d="M13.7461 9.49219C11.4005 9.49219 9.49219 11.4005 9.49219 13.7461C9.49219 16.0917 11.4005 18 13.7461 18C16.0917 18 18 16.0917 18 13.7461C18 11.4005 16.0917 9.49219 13.7461 9.49219ZM13.7461 16.5938C12.1759 16.5938 10.8984 15.3163 10.8984 13.7461C10.8984 12.1759 12.1759 10.8984 13.7461 10.8984C15.3163 10.8984 16.5938 12.1759 16.5938 13.7461C16.5938 15.3163 15.3163 16.5938 13.7461 16.5938Z"
      fill="#8181A5"
    />
    <path
      d="M14.7656 13.043H14.4492V12.3047C14.4492 11.9164 14.1344 11.6016 13.7461 11.6016C13.3578 11.6016 13.043 11.9164 13.043 12.3047V13.7461C13.043 14.1344 13.3578 14.4492 13.7461 14.4492H14.7656C15.154 14.4492 15.4688 14.1344 15.4688 13.7461C15.4688 13.3578 15.154 13.043 14.7656 13.043Z"
      fill="#8181A5"
    />
    <path
      d="M10.5117 8.08594C10.9 8.08594 11.2148 7.77114 11.2148 7.38281C11.2148 6.99449 10.9 6.67969 10.5117 6.67969C10.1234 6.67969 9.80859 6.99449 9.80859 7.38281C9.80859 7.77114 10.1234 8.08594 10.5117 8.08594Z"
      fill="#8181A5"
    />
    <path
      d="M7.45312 11.1406C7.84145 11.1406 8.15625 10.8258 8.15625 10.4375C8.15625 10.0492 7.84145 9.73438 7.45312 9.73438C7.0648 9.73438 6.75 10.0492 6.75 10.4375C6.75 10.8258 7.0648 11.1406 7.45312 11.1406Z"
      fill="#8181A5"
    />
    <path
      d="M4.39453 8.08594C4.78286 8.08594 5.09766 7.77114 5.09766 7.38281C5.09766 6.99449 4.78286 6.67969 4.39453 6.67969C4.00621 6.67969 3.69141 6.99449 3.69141 7.38281C3.69141 7.77114 4.00621 8.08594 4.39453 8.08594Z"
      fill="#8181A5"
    />
    <path
      d="M4.39453 11.1406C4.78286 11.1406 5.09766 10.8258 5.09766 10.4375C5.09766 10.0492 4.78286 9.73438 4.39453 9.73438C4.00621 9.73438 3.69141 10.0492 3.69141 10.4375C3.69141 10.8258 4.00621 11.1406 4.39453 11.1406Z"
      fill="#8181A5"
    />
    <path
      d="M4.39453 14.2031C4.78286 14.2031 5.09766 13.8883 5.09766 13.5C5.09766 13.1117 4.78286 12.7969 4.39453 12.7969C4.00621 12.7969 3.69141 13.1117 3.69141 13.5C3.69141 13.8883 4.00621 14.2031 4.39453 14.2031Z"
      fill="#8181A5"
    />
    <path
      d="M7.45312 14.2031C7.84145 14.2031 8.15625 13.8883 8.15625 13.5C8.15625 13.1117 7.84145 12.7969 7.45312 12.7969C7.0648 12.7969 6.75 13.1117 6.75 13.5C6.75 13.8883 7.0648 14.2031 7.45312 14.2031Z"
      fill="#8181A5"
    />
    <path
      d="M7.45312 8.08594C7.84145 8.08594 8.15625 7.77114 8.15625 7.38281C8.15625 6.99449 7.84145 6.67969 7.45312 6.67969C7.0648 6.67969 6.75 6.99449 6.75 7.38281C6.75 7.77114 7.0648 8.08594 7.45312 8.08594Z"
      fill="#8181A5"
    />
  </svg>
);
export const PlusIconSmall = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 2.5V9.5"
      stroke="#8181A5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.5 6H9.5"
      stroke="#8181A5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const ReassignIcon = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 10.5V9.5C8 8.96957 7.78929 8.46086 7.41421 8.08579C7.03914 7.71071 6.53043 7.5 6 7.5H2.5C1.96957 7.5 1.46086 7.71071 1.08579 8.08579C0.710714 8.46086 0.5 8.96957 0.5 9.5V10.5"
      stroke="#8181A5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.25 5.5C5.35457 5.5 6.25 4.60457 6.25 3.5C6.25 2.39543 5.35457 1.5 4.25 1.5C3.14543 1.5 2.25 2.39543 2.25 3.5C2.25 4.60457 3.14543 5.5 4.25 5.5Z"
      stroke="#8181A5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 4V7"
      stroke="#8181A5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.5 5.5H8.5"
      stroke="#8181A5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const CancelIconCircle = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_527_41821)">
      <path
        d="M3.93 1H8.07L11 3.93V8.07L8.07 11H3.93L1 8.07V3.93L3.93 1Z"
        stroke="#8181A5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 4.5L4.5 7.5"
        stroke="#8181A5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.5 4.5L7.5 7.5"
        stroke="#8181A5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_527_41821">
        <rect width="12" height="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export const TickIconCircle = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="24" height="24" rx="4" fill="#FBFAFD" />
    <g clipPath="url(#clip0_527_53350)">
      <path
        d="M17 11.539V11.999C16.9994 13.0772 16.6503 14.1263 16.0047 14.9899C15.3591 15.8534 14.4516 16.4852 13.4177 16.7909C12.3837 17.0966 11.2786 17.0599 10.2672 16.6862C9.25584 16.3126 8.39233 15.622 7.80548 14.7175C7.21863 13.813 6.9399 12.743 7.01084 11.6671C7.08178 10.5912 7.4986 9.56712 8.19914 8.74749C8.89968 7.92787 9.84639 7.35665 10.8981 7.11903C11.9498 6.88141 13.0501 6.99012 14.035 7.42896"
        stroke="#8181A5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17 8L12 13.005L10.5 11.505"
        stroke="#8181A5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_527_53350">
        <rect width="12" height="12" fill="white" transform="translate(6 6)" />
      </clipPath>
    </defs>
  </svg>
);
export const EditPenIconSquare = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="24" height="24" rx="4" fill="white" />
    <path
      d="M12 16H16.5"
      stroke="#7D63EC"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.25 7.74816C14.4489 7.54925 14.7187 7.4375 15 7.4375C15.1393 7.4375 15.2772 7.46493 15.4059 7.51824C15.5346 7.57154 15.6515 7.64967 15.75 7.74816C15.8485 7.84665 15.9266 7.96358 15.9799 8.09226C16.0332 8.22095 16.0607 8.35887 16.0607 8.49816C16.0607 8.63745 16.0332 8.77537 15.9799 8.90406C15.9266 9.03274 15.8485 9.14967 15.75 9.24816L9.5 15.4982L7.5 15.9982L8 13.9982L14.25 7.74816Z"
      stroke="#7D63EC"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const CancelSquareIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="24" height="24" rx="4" fill="#FBFAFD" />
    <g clipPath="url(#clip0_527_53358)">
      <path
        d="M9.93 7H14.07L17 9.93V14.07L14.07 17H9.93L7 14.07V9.93L9.93 7Z"
        stroke="#8181A5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.5 10.5L10.5 13.5"
        stroke="#8181A5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.5 10.5L13.5 13.5"
        stroke="#8181A5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_527_53358">
        <rect width="12" height="12" fill="white" transform="translate(6 6)" />
      </clipPath>
    </defs>
  </svg>
);
export const DeleteIconPurpleSquare = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="24" height="24" rx="2" fill="white" />
    <rect width="24" height="24" rx="2" fill="#4D4CAC" fill-opacity="0.06" />
    <path
      d="M6 8H7.33333H18"
      stroke="#8181A5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.33398 7.9987V6.66536C9.33398 6.31174 9.47446 5.9726 9.72451 5.72256C9.97456 5.47251 10.3137 5.33203 10.6673 5.33203H13.334C13.6876 5.33203 14.0267 5.47251 14.2768 5.72256C14.5268 5.9726 14.6673 6.31174 14.6673 6.66536V7.9987M16.6673 7.9987V17.332C16.6673 17.6857 16.5268 18.0248 16.2768 18.2748C16.0267 18.5249 15.6876 18.6654 15.334 18.6654H8.66732C8.3137 18.6654 7.97456 18.5249 7.72451 18.2748C7.47446 18.0248 7.33398 17.6857 7.33398 17.332V7.9987H16.6673Z"
      stroke="#8181A5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.666 11.332V15.332"
      stroke="#8181A5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.334 11.332V15.332"
      stroke="#8181A5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const EditIconPurpleSquare = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="24" height="24" rx="2" fill="white" />
    <rect width="24" height="24" rx="2" fill="#4D4CAC" fill-opacity="0.06" />
    <path
      d="M12 17.332H18"
      stroke="#8181A5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15 6.33218C15.2652 6.06697 15.6249 5.91797 16 5.91797C16.1857 5.91797 16.3696 5.95455 16.5412 6.02562C16.7128 6.09669 16.8687 6.20086 17 6.33218C17.1313 6.4635 17.2355 6.61941 17.3066 6.79099C17.3776 6.96257 17.4142 7.14647 17.4142 7.33218C17.4142 7.5179 17.3776 7.7018 17.3066 7.87338C17.2355 8.04496 17.1313 8.20086 17 8.33218L8.66667 16.6655L6 17.3322L6.66667 14.6655L15 6.33218Z"
      stroke="#8181A5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const CalenderNotification = () => (
  <svg
    width="12"
    height="20"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.01562 4.92188C9.01562 4.90462 9.02962 4.89062 9.04688 4.89062C9.06413 4.89062 9.07812 4.90462 9.07812 4.92188C9.07812 4.93913 9.06413 4.95312 9.04688 4.95312C9.02962 4.95312 9.01562 4.93913 9.01562 4.92188Z"
      fill="#888888"
      stroke="#888888"
    />
    <mask id="path-2-inside-1_719_516" fill="white">
      <path d="M10.125 0.9375H9.51562V0.46875C9.51562 0.209859 9.30577 0 9.04688 0C8.78798 0 8.57812 0.209859 8.57812 0.46875V0.9375H6.44531V0.46875C6.44531 0.209859 6.23545 0 5.97656 0C5.71767 0 5.50781 0.209859 5.50781 0.46875V0.9375H3.39844V0.46875C3.39844 0.209859 3.18858 0 2.92969 0C2.6708 0 2.46094 0.209859 2.46094 0.46875V0.9375H1.875C0.841125 0.9375 0 1.77863 0 2.8125V10.125C0 11.1589 0.841125 12 1.875 12H5.46094C5.71983 12 5.92969 11.7901 5.92969 11.5312C5.92969 11.2724 5.71983 11.0625 5.46094 11.0625H1.875C1.35806 11.0625 0.9375 10.6419 0.9375 10.125V2.8125C0.9375 2.29556 1.35806 1.875 1.875 1.875H2.46094V2.34375C2.46094 2.60264 2.6708 2.8125 2.92969 2.8125C3.18858 2.8125 3.39844 2.60264 3.39844 2.34375V1.875H5.50781V2.34375C5.50781 2.60264 5.71767 2.8125 5.97656 2.8125C6.23545 2.8125 6.44531 2.60264 6.44531 2.34375V1.875H8.57812V2.34375C8.57812 2.60264 8.78798 2.8125 9.04688 2.8125C9.30577 2.8125 9.51562 2.60264 9.51562 2.34375V1.875H10.125C10.6419 1.875 11.0625 2.29556 11.0625 2.8125V5.48438C11.0625 5.74327 11.2724 5.95312 11.5312 5.95312C11.7901 5.95312 12 5.74327 12 5.48438V2.8125C12 1.77863 11.1589 0.9375 10.125 0.9375Z" />
    </mask>
    <path
      d="M10.125 0.9375H9.51562V0.46875C9.51562 0.209859 9.30577 0 9.04688 0C8.78798 0 8.57812 0.209859 8.57812 0.46875V0.9375H6.44531V0.46875C6.44531 0.209859 6.23545 0 5.97656 0C5.71767 0 5.50781 0.209859 5.50781 0.46875V0.9375H3.39844V0.46875C3.39844 0.209859 3.18858 0 2.92969 0C2.6708 0 2.46094 0.209859 2.46094 0.46875V0.9375H1.875C0.841125 0.9375 0 1.77863 0 2.8125V10.125C0 11.1589 0.841125 12 1.875 12H5.46094C5.71983 12 5.92969 11.7901 5.92969 11.5312C5.92969 11.2724 5.71983 11.0625 5.46094 11.0625H1.875C1.35806 11.0625 0.9375 10.6419 0.9375 10.125V2.8125C0.9375 2.29556 1.35806 1.875 1.875 1.875H2.46094V2.34375C2.46094 2.60264 2.6708 2.8125 2.92969 2.8125C3.18858 2.8125 3.39844 2.60264 3.39844 2.34375V1.875H5.50781V2.34375C5.50781 2.60264 5.71767 2.8125 5.97656 2.8125C6.23545 2.8125 6.44531 2.60264 6.44531 2.34375V1.875H8.57812V2.34375C8.57812 2.60264 8.78798 2.8125 9.04688 2.8125C9.30577 2.8125 9.51562 2.60264 9.51562 2.34375V1.875H10.125C10.6419 1.875 11.0625 2.29556 11.0625 2.8125V5.48438C11.0625 5.74327 11.2724 5.95312 11.5312 5.95312C11.7901 5.95312 12 5.74327 12 5.48438V2.8125C12 1.77863 11.1589 0.9375 10.125 0.9375Z"
      fill="#888888"
    />
    <path
      d="M9.51562 0.9375H8.51562V1.9375H9.51562V0.9375ZM8.57812 0.9375V1.9375H9.57812V0.9375H8.57812ZM6.44531 0.9375H5.44531V1.9375H6.44531V0.9375ZM5.50781 0.9375V1.9375H6.50781V0.9375H5.50781ZM3.39844 0.9375H2.39844V1.9375H3.39844V0.9375ZM2.46094 0.9375V1.9375H3.46094V0.9375H2.46094ZM2.46094 1.875H3.46094V0.875H2.46094V1.875ZM3.39844 1.875V0.875H2.39844V1.875H3.39844ZM5.50781 1.875H6.50781V0.875H5.50781V1.875ZM6.44531 1.875V0.875H5.44531V1.875H6.44531ZM8.57812 1.875H9.57812V0.875H8.57812V1.875ZM9.51562 1.875V0.875H8.51562V1.875H9.51562ZM10.125 -0.0625H9.51562V1.9375H10.125V-0.0625ZM10.5156 0.9375V0.46875H8.51562V0.9375H10.5156ZM10.5156 0.46875C10.5156 -0.342425 9.85805 -1 9.04688 -1V1C8.75348 1 8.51562 0.762144 8.51562 0.46875H10.5156ZM9.04688 -1C8.2357 -1 7.57812 -0.342425 7.57812 0.46875H9.57812C9.57812 0.762144 9.34027 1 9.04688 1V-1ZM7.57812 0.46875V0.9375H9.57812V0.46875H7.57812ZM8.57812 -0.0625H6.44531V1.9375H8.57812V-0.0625ZM7.44531 0.9375V0.46875H5.44531V0.9375H7.44531ZM7.44531 0.46875C7.44531 -0.342425 6.78774 -1 5.97656 -1V1C5.68317 1 5.44531 0.762144 5.44531 0.46875H7.44531ZM5.97656 -1C5.16539 -1 4.50781 -0.342425 4.50781 0.46875H6.50781C6.50781 0.762144 6.26996 1 5.97656 1V-1ZM4.50781 0.46875V0.9375H6.50781V0.46875H4.50781ZM5.50781 -0.0625H3.39844V1.9375H5.50781V-0.0625ZM4.39844 0.9375V0.46875H2.39844V0.9375H4.39844ZM4.39844 0.46875C4.39844 -0.342425 3.74086 -1 2.92969 -1V1C2.63629 1 2.39844 0.762144 2.39844 0.46875H4.39844ZM2.92969 -1C2.11851 -1 1.46094 -0.342425 1.46094 0.46875H3.46094C3.46094 0.762144 3.22308 1 2.92969 1V-1ZM1.46094 0.46875V0.9375H3.46094V0.46875H1.46094ZM2.46094 -0.0625H1.875V1.9375H2.46094V-0.0625ZM1.875 -0.0625C0.28884 -0.0625 -1 1.22634 -1 2.8125H1C1 2.33091 1.39341 1.9375 1.875 1.9375V-0.0625ZM-1 2.8125V10.125H1V2.8125H-1ZM-1 10.125C-1 11.7112 0.28884 13 1.875 13V11C1.39341 11 1 10.6066 1 10.125H-1ZM1.875 13H5.46094V11H1.875V13ZM5.46094 13C6.27211 13 6.92969 12.3424 6.92969 11.5312H4.92969C4.92969 11.2379 5.16754 11 5.46094 11V13ZM6.92969 11.5312C6.92969 10.7201 6.27211 10.0625 5.46094 10.0625V12.0625C5.16754 12.0625 4.92969 11.8246 4.92969 11.5312H6.92969ZM5.46094 10.0625H1.875V12.0625H5.46094V10.0625ZM1.875 10.0625C1.89327 10.0625 1.91003 10.071 1.91951 10.0805C1.92898 10.09 1.9375 10.1067 1.9375 10.125H-0.0625C-0.0625 11.1942 0.805778 12.0625 1.875 12.0625V10.0625ZM1.9375 10.125V2.8125H-0.0625V10.125H1.9375ZM1.9375 2.8125C1.9375 2.83077 1.92898 2.84753 1.91951 2.85701C1.91003 2.86648 1.89327 2.875 1.875 2.875V0.875C0.805778 0.875 -0.0625 1.74328 -0.0625 2.8125H1.9375ZM1.875 2.875H2.46094V0.875H1.875V2.875ZM1.46094 1.875V2.34375H3.46094V1.875H1.46094ZM1.46094 2.34375C1.46094 3.15493 2.11851 3.8125 2.92969 3.8125V1.8125C3.22308 1.8125 3.46094 2.05036 3.46094 2.34375H1.46094ZM2.92969 3.8125C3.74086 3.8125 4.39844 3.15493 4.39844 2.34375H2.39844C2.39844 2.05036 2.63629 1.8125 2.92969 1.8125V3.8125ZM4.39844 2.34375V1.875H2.39844V2.34375H4.39844ZM3.39844 2.875H5.50781V0.875H3.39844V2.875ZM4.50781 1.875V2.34375H6.50781V1.875H4.50781ZM4.50781 2.34375C4.50781 3.15493 5.16539 3.8125 5.97656 3.8125V1.8125C6.26996 1.8125 6.50781 2.05036 6.50781 2.34375H4.50781ZM5.97656 3.8125C6.78774 3.8125 7.44531 3.15493 7.44531 2.34375H5.44531C5.44531 2.05036 5.68317 1.8125 5.97656 1.8125V3.8125ZM7.44531 2.34375V1.875H5.44531V2.34375H7.44531ZM6.44531 2.875H8.57812V0.875H6.44531V2.875ZM7.57812 1.875V2.34375H9.57812V1.875H7.57812ZM7.57812 2.34375C7.57812 3.15493 8.2357 3.8125 9.04688 3.8125V1.8125C9.34027 1.8125 9.57812 2.05036 9.57812 2.34375H7.57812ZM9.04688 3.8125C9.85805 3.8125 10.5156 3.15493 10.5156 2.34375H8.51562C8.51562 2.05036 8.75348 1.8125 9.04688 1.8125V3.8125ZM10.5156 2.34375V1.875H8.51562V2.34375H10.5156ZM9.51562 2.875H10.125V0.875H9.51562V2.875ZM10.125 2.875C10.1067 2.875 10.09 2.86648 10.0805 2.85701C10.071 2.84753 10.0625 2.83077 10.0625 2.8125H12.0625C12.0625 1.74328 11.1942 0.875 10.125 0.875V2.875ZM10.0625 2.8125V5.48438H12.0625V2.8125H10.0625ZM10.0625 5.48438C10.0625 6.29555 10.7201 6.95312 11.5312 6.95312V4.95312C11.8246 4.95312 12.0625 5.19098 12.0625 5.48438H10.0625ZM11.5312 6.95312C12.3424 6.95312 13 6.29555 13 5.48438H11C11 5.19098 11.2379 4.95312 11.5312 4.95312V6.95312ZM13 5.48438V2.8125H11V5.48438H13ZM13 2.8125C13 1.22634 11.7112 -0.0625 10.125 -0.0625V1.9375C10.6066 1.9375 11 2.33091 11 2.8125H13Z"
      fill="#888888"
      mask="url(#path-2-inside-1_719_516)"
    />
    <path
      d="M9.16406 6.32812C7.60031 6.32812 6.32812 7.60031 6.32812 9.16406C6.32812 10.7278 7.60031 12 9.16406 12C10.7278 12 12 10.7278 12 9.16406C12 7.60031 10.7278 6.32812 9.16406 6.32812ZM9.16406 11.0625C8.11727 11.0625 7.26562 10.2109 7.26562 9.16406C7.26562 8.11725 8.11727 7.26562 9.16406 7.26562C10.2109 7.26562 11.0625 8.11725 11.0625 9.16406C11.0625 10.2109 10.2109 11.0625 9.16406 11.0625Z"
      fill="#888888"
    />
    <path
      d="M9.84375 8.69531H9.63281V8.20312C9.63281 7.94423 9.42295 7.73438 9.16406 7.73438C8.90517 7.73438 8.69531 7.94423 8.69531 8.20312V9.16406C8.69531 9.42295 8.90517 9.63281 9.16406 9.63281H9.84375C10.1026 9.63281 10.3125 9.42295 10.3125 9.16406C10.3125 8.90517 10.1026 8.69531 9.84375 8.69531Z"
      fill="#888888"
    />
    <path
      d="M7.00781 5.39062C7.2667 5.39062 7.47656 5.18076 7.47656 4.92188C7.47656 4.66299 7.2667 4.45312 7.00781 4.45312C6.74893 4.45312 6.53906 4.66299 6.53906 4.92188C6.53906 5.18076 6.74893 5.39062 7.00781 5.39062Z"
      fill="#888888"
    />
    <path
      d="M4.96875 7.42969C5.22763 7.42969 5.4375 7.21982 5.4375 6.96094C5.4375 6.70205 5.22763 6.49219 4.96875 6.49219C4.70987 6.49219 4.5 6.70205 4.5 6.96094C4.5 7.21982 4.70987 7.42969 4.96875 7.42969Z"
      fill="#888888"
    />
    <path
      d="M2.92969 5.39062C3.18857 5.39062 3.39844 5.18076 3.39844 4.92188C3.39844 4.66299 3.18857 4.45312 2.92969 4.45312C2.6708 4.45312 2.46094 4.66299 2.46094 4.92188C2.46094 5.18076 2.6708 5.39062 2.92969 5.39062Z"
      fill="#888888"
    />
    <path
      d="M2.92969 7.42969C3.18857 7.42969 3.39844 7.21982 3.39844 6.96094C3.39844 6.70205 3.18857 6.49219 2.92969 6.49219C2.6708 6.49219 2.46094 6.70205 2.46094 6.96094C2.46094 7.21982 2.6708 7.42969 2.92969 7.42969Z"
      fill="#888888"
    />
    <path
      d="M2.92969 9.46875C3.18857 9.46875 3.39844 9.25888 3.39844 9C3.39844 8.74112 3.18857 8.53125 2.92969 8.53125C2.6708 8.53125 2.46094 8.74112 2.46094 9C2.46094 9.25888 2.6708 9.46875 2.92969 9.46875Z"
      fill="#888888"
    />
    <path
      d="M4.96875 9.46875C5.22763 9.46875 5.4375 9.25888 5.4375 9C5.4375 8.74112 5.22763 8.53125 4.96875 8.53125C4.70987 8.53125 4.5 8.74112 4.5 9C4.5 9.25888 4.70987 9.46875 4.96875 9.46875Z"
      fill="#888888"
    />
    <path
      d="M4.96875 5.39062C5.22763 5.39062 5.4375 5.18076 5.4375 4.92188C5.4375 4.66299 5.22763 4.45312 4.96875 4.45312C4.70987 4.45312 4.5 4.66299 4.5 4.92188C4.5 5.18076 4.70987 5.39062 4.96875 5.39062Z"
      fill="#888888"
    />
  </svg>
);
export const AccessTickIconPurple = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14 0.5L4.7 10.725L2 8.675H0.5L4.7 15.5L15.5 0.5H14Z"
      fill="#7D63EC"
    />
  </svg>
);
export const AccessDashIconGrey = () => (
  <svg
    width="14"
    height="2"
    viewBox="0 0 14 2"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M1 1H13" stroke="#ABB2B3" strokeLinecap="round" />
  </svg>
);
export const EditIconSmall = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 10H10.5"
      stroke="#8181A5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.25 1.74999C8.44891 1.55108 8.7187 1.43933 9 1.43933C9.13929 1.43933 9.27721 1.46677 9.4059 1.52007C9.53458 1.57337 9.65151 1.6515 9.75 1.74999C9.84849 1.84848 9.92662 1.96541 9.97992 2.09409C10.0332 2.22278 10.0607 2.3607 10.0607 2.49999C10.0607 2.63928 10.0332 2.7772 9.97992 2.90589C9.92662 3.03457 9.84849 3.1515 9.75 3.24999L3.5 9.49999L1.5 9.99999L2 7.99999L8.25 1.74999Z"
      stroke="#8181A5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const TickCircleIconSmall = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_247_503)">
      <path
        d="M11 5.54005V6.00005C10.9994 7.07827 10.6503 8.12739 10.0047 8.99097C9.35908 9.85454 8.45164 10.4863 7.41768 10.792C6.38372 11.0977 5.27863 11.061 4.26724 10.6873C3.25584 10.3137 2.39233 9.6231 1.80548 8.71859C1.21863 7.81407 0.939896 6.74409 1.01084 5.66821C1.08178 4.59234 1.4986 3.56822 2.19914 2.74859C2.89968 1.92896 3.84639 1.35775 4.89809 1.12013C5.9498 0.882509 7.05013 0.991223 8.035 1.43005"
        stroke="#8181A5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 2L6 7.005L4.5 5.505"
        stroke="#8181A5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_247_503">
        <rect width="12" height="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export const TrashIconSmall = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.5 3H2.5H10.5"
      stroke="#8181A5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4 3V2C4 1.73478 4.10536 1.48043 4.29289 1.29289C4.48043 1.10536 4.73478 1 5 1H7C7.26522 1 7.51957 1.10536 7.70711 1.29289C7.89464 1.48043 8 1.73478 8 2V3M9.5 3V10C9.5 10.2652 9.39464 10.5196 9.20711 10.7071C9.01957 10.8946 8.76522 11 8.5 11H3.5C3.23478 11 2.98043 10.8946 2.79289 10.7071C2.60536 10.5196 2.5 10.2652 2.5 10V3H9.5Z"
      stroke="#8181A5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5 5.5V8.5"
      stroke="#8181A5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7 5.5V8.5"
      stroke="#8181A5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DownloadIcon = () => {
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14 10V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V10"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.66699 6.66602L8.00033 9.99935L11.3337 6.66602"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 10V2"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>;
};

export const DownloadIconPurple = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 10V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V10"
        stroke="#8181A5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.66699 6.66602L8.00033 9.99935L11.3337 6.66602"
        stroke="#8181A5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 10V2"
        stroke="#8181A5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const CrossIconDark = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.5 3.5L3.5 10.5"
        stroke="#1C1D21"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.5 3.5L10.5 10.5"
        stroke="#1C1D21"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DiscardIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="4" fill="#FBFAFD" />
      <path
        d="M15.5 7.5H8.5C7.94772 7.5 7.5 7.94772 7.5 8.5V15.5C7.5 16.0523 7.94772 16.5 8.5 16.5H15.5C16.0523 16.5 16.5 16.0523 16.5 15.5V8.5C16.5 7.94772 16.0523 7.5 15.5 7.5Z"
        stroke="#8181A5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.5 10.5L13.5 13.5"
        stroke="#8181A5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.5 10.5L10.5 13.5"
        stroke="#8181A5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ClockIcon = () => {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.49967 14.6654C12.1816 14.6654 15.1663 11.6806 15.1663 7.9987C15.1663 4.3168 12.1816 1.33203 8.49967 1.33203C4.81778 1.33203 1.83301 4.3168 1.83301 7.9987C1.83301 11.6806 4.81778 14.6654 8.49967 14.6654Z"
        stroke="red"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.5 4V8L11.1667 9.33333"
        stroke="#red"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CalenderDetails = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_15613_338188)">
        <path
          d="M10.6016 5.74219C10.6016 5.76808 10.5806 5.78906 10.5547 5.78906C10.5288 5.78906 10.5078 5.76808 10.5078 5.74219C10.5078 5.7163 10.5288 5.69531 10.5547 5.69531C10.5806 5.69531 10.6016 5.7163 10.6016 5.74219Z"
          fill="#F5F4FF"
          stroke="#888888"
        />
        <path
          d="M10.6016 1.09375V1.59375H11.1016H11.8125C12.7425 1.59375 13.5 2.3512 13.5 3.28125V6.39844C13.5 6.42433 13.479 6.44531 13.4531 6.44531C13.4272 6.44531 13.4062 6.42433 13.4062 6.39844V3.28125C13.4062 2.40201 12.6917 1.6875 11.8125 1.6875H11.1016H10.6016V2.1875V2.73438C10.6016 2.76027 10.5806 2.78125 10.5547 2.78125C10.5288 2.78125 10.5078 2.76027 10.5078 2.73438V2.1875V1.6875H10.0078H7.51953H7.01953V2.1875V2.73438C7.01953 2.76027 6.99855 2.78125 6.97266 2.78125C6.94676 2.78125 6.92578 2.76027 6.92578 2.73438V2.1875V1.6875H6.42578H3.96484H3.46484V2.1875V2.73438C3.46484 2.76027 3.44387 2.78125 3.41797 2.78125C3.39207 2.78125 3.37109 2.76027 3.37109 2.73438V2.1875V1.6875H2.87109H2.1875C1.30826 1.6875 0.59375 2.40201 0.59375 3.28125V11.8125C0.59375 12.6917 1.30826 13.4062 2.1875 13.4062H6.37109C6.39699 13.4062 6.41797 13.4272 6.41797 13.4531C6.41797 13.479 6.39699 13.5 6.37109 13.5H2.1875C1.25745 13.5 0.5 12.7425 0.5 11.8125V3.28125C0.5 2.3512 1.25745 1.59375 2.1875 1.59375H2.87109H3.37109V1.09375V0.546875C3.37109 0.520978 3.39207 0.5 3.41797 0.5C3.44387 0.5 3.46484 0.520978 3.46484 0.546875V1.09375V1.59375H3.96484H6.42578H6.92578V1.09375V0.546875C6.92578 0.520978 6.94676 0.5 6.97266 0.5C6.99855 0.5 7.01953 0.520978 7.01953 0.546875V1.09375V1.59375H7.51953H10.0078H10.5078V1.09375V0.546875C10.5078 0.520978 10.5288 0.5 10.5547 0.5C10.5806 0.5 10.6016 0.520978 10.6016 0.546875V1.09375Z"
          fill="#888888"
          stroke="#888888"
        />
        <path
          d="M7.88281 10.6914C7.88281 9.14317 9.14317 7.88281 10.6914 7.88281C12.2396 7.88281 13.5 9.14317 13.5 10.6914C13.5 12.2396 12.2396 13.5 10.6914 13.5C9.14317 13.5 7.88281 12.2396 7.88281 10.6914ZM7.97656 10.6914C7.97656 12.1888 9.19401 13.4062 10.6914 13.4062C12.1888 13.4062 13.4062 12.1888 13.4062 10.6914C13.4062 9.19398 12.1888 7.97656 10.6914 7.97656C9.19401 7.97656 7.97656 9.19398 7.97656 10.6914Z"
          fill="#888888"
          stroke="#888888"
        />
        <path
          d="M10.7383 10.1445V10.6445H11.2383H11.4844C11.5103 10.6445 11.5312 10.6655 11.5312 10.6914C11.5312 10.7173 11.5103 10.7383 11.4844 10.7383H10.6914C10.6655 10.7383 10.6445 10.7173 10.6445 10.6914V9.57031C10.6445 9.54442 10.6655 9.52344 10.6914 9.52344C10.7173 9.52344 10.7383 9.54442 10.7383 9.57031V10.1445Z"
          fill="#888888"
          stroke="#888888"
        />
        <path
          d="M8.17578 6.28906C8.47781 6.28906 8.72266 6.04422 8.72266 5.74219C8.72266 5.44016 8.47781 5.19531 8.17578 5.19531C7.87375 5.19531 7.62891 5.44016 7.62891 5.74219C7.62891 6.04422 7.87375 6.28906 8.17578 6.28906Z"
          fill="#888888"
        />
        <path
          d="M5.79688 8.66797C6.09891 8.66797 6.34375 8.42312 6.34375 8.12109C6.34375 7.81906 6.09891 7.57422 5.79688 7.57422C5.49484 7.57422 5.25 7.81906 5.25 8.12109C5.25 8.42312 5.49484 8.66797 5.79688 8.66797Z"
          fill="#888888"
        />
        <path
          d="M3.41797 6.28906C3.72 6.28906 3.96484 6.04422 3.96484 5.74219C3.96484 5.44016 3.72 5.19531 3.41797 5.19531C3.11594 5.19531 2.87109 5.44016 2.87109 5.74219C2.87109 6.04422 3.11594 6.28906 3.41797 6.28906Z"
          fill="#888888"
        />
        <path
          d="M3.41797 8.66797C3.72 8.66797 3.96484 8.42312 3.96484 8.12109C3.96484 7.81906 3.72 7.57422 3.41797 7.57422C3.11594 7.57422 2.87109 7.81906 2.87109 8.12109C2.87109 8.42312 3.11594 8.66797 3.41797 8.66797Z"
          fill="#888888"
        />
        <path
          d="M3.41797 11.0469C3.72 11.0469 3.96484 10.802 3.96484 10.5C3.96484 10.198 3.72 9.95312 3.41797 9.95312C3.11594 9.95312 2.87109 10.198 2.87109 10.5C2.87109 10.802 3.11594 11.0469 3.41797 11.0469Z"
          fill="#888888"
        />
        <path
          d="M5.79688 11.0469C6.09891 11.0469 6.34375 10.802 6.34375 10.5C6.34375 10.198 6.09891 9.95312 5.79688 9.95312C5.49484 9.95312 5.25 10.198 5.25 10.5C5.25 10.802 5.49484 11.0469 5.79688 11.0469Z"
          fill="#888888"
        />
        <path
          d="M5.79688 6.28906C6.09891 6.28906 6.34375 6.04422 6.34375 5.74219C6.34375 5.44016 6.09891 5.19531 5.79688 5.19531C5.49484 5.19531 5.25 5.44016 5.25 5.74219C5.25 6.04422 5.49484 6.28906 5.79688 6.28906Z"
          fill="#888888"
        />
      </g>
      <defs>
        <clipPath id="clip0_15613_338188">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const AlertIconGreen = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.71758 2.89497L1.36508 13.5C1.2341 13.7268 1.1648 13.9839 1.16407 14.2459C1.16334 14.5078 1.23119 14.7653 1.3609 14.9929C1.4906 15.2204 1.67762 15.41 1.90336 15.5429C2.12909 15.6757 2.38568 15.7471 2.64758 15.75H15.3526C15.6145 15.7471 15.8711 15.6757 16.0968 15.5429C16.3225 15.41 16.5096 15.2204 16.6393 14.9929C16.769 14.7653 16.8368 14.5078 16.8361 14.2459C16.8354 13.9839 16.7661 13.7268 16.6351 13.5L10.2826 2.89497C10.1489 2.67455 9.96062 2.49231 9.73597 2.36583C9.51133 2.23936 9.25788 2.17291 9.00008 2.17291C8.74228 2.17291 8.48883 2.23936 8.26418 2.36583C8.03954 2.49231 7.85128 2.67455 7.71758 2.89497Z"
        fill="#1CB161"
        stroke="#1CB161"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 6.75V9.75"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 12.75H9.0075"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CounterIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_15304_243845"
        style="mask-type:luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <path d="M0 0H24V24H0V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_15304_243845)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M23.7071 5.29289C24.0976 5.68342 24.0976 6.31658 23.7071 6.70711L14.2071 16.2071C13.8166 16.5976 13.1834 16.5976 12.7929 16.2071L8.5 11.9142L1.70711 18.7071C1.31658 19.0976 0.683417 19.0976 0.292893 18.7071C-0.097631 18.3166 -0.097631 17.6834 0.292893 17.2929L7.79289 9.79289C8.18342 9.40237 8.81658 9.40237 9.20711 9.79289L13.5 14.0858L22.2929 5.29289C22.6834 4.90237 23.3166 4.90237 23.7071 5.29289Z"
          fill="#1CB161"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M16 6C16 5.44772 16.4477 5 17 5H23C23.5523 5 24 5.44772 24 6V12C24 12.5523 23.5523 13 23 13C22.4477 13 22 12.5523 22 12V7H17C16.4477 7 16 6.55228 16 6Z"
          fill="#1CB161"
        />
      </g>
    </svg>
  );
};

export const EyeIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="4" fill="#FBFAFD" />
      <path
        d="M6.5 12C6.5 12 8.5 8 12 8C15.5 8 17.5 12 17.5 12C17.5 12 15.5 16 12 16C8.5 16 6.5 12 6.5 12Z"
        stroke="#8181A5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 13.5C12.8284 13.5 13.5 12.8284 13.5 12C13.5 11.1716 12.8284 10.5 12 10.5C11.1716 10.5 10.5 11.1716 10.5 12C10.5 12.8284 11.1716 13.5 12 13.5Z"
        stroke="#8181A5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ChevronDown = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.5 5.25L7 8.75L10.5 5.25"
        stroke="#0000008a"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PersonIcon = () => {
  return (
    <svg
      width="13"
      height="14"
      viewBox="0 0 13 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.8334 11.875V10.7917C10.8334 10.217 10.6051 9.66593 10.1988 9.2596C9.79248 8.85327 9.24138 8.625 8.66675 8.625H4.33341C3.75878 8.625 3.20768 8.85327 2.80135 9.2596C2.39502 9.66593 2.16675 10.217 2.16675 10.7917V11.875"
        stroke="#58596B"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.49992 6.45833C7.69654 6.45833 8.66659 5.48828 8.66659 4.29167C8.66659 3.09505 7.69654 2.125 6.49992 2.125C5.3033 2.125 4.33325 3.09505 4.33325 4.29167C4.33325 5.48828 5.3033 6.45833 6.49992 6.45833Z"
        stroke="#58596B"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ReportsIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.3337 8.33341V12.5001C18.3337 16.6667 16.667 18.3334 12.5003 18.3334H7.50033C3.33366 18.3334 1.66699 16.6667 1.66699 12.5001V7.50008C1.66699 3.33341 3.33366 1.66675 7.50033 1.66675H11.667"
        stroke="#8181A5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.3337 8.33341H15.0003C12.5003 8.33341 11.667 7.50008 11.667 5.00008V1.66675L18.3337 8.33341Z"
        stroke="#8181A5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.83301 10.8333H10.833"
        stroke="#8181A5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.83301 14.1667H9.16634"
        stroke="#8181A5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DownloadIconWhite = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.8801 6.43133H9.88242V3.29408C9.88242 2.94898 9.60007 2.66663 9.25497 2.66663H6.74517C6.40007 2.66663 6.11772 2.94898 6.11772 3.29408V6.43133H5.12007C4.56164 6.43133 4.27929 7.10898 4.67458 7.50427L7.55458 10.3843C7.79929 10.629 8.19458 10.629 8.43929 10.3843L11.3193 7.50427C11.7146 7.10898 11.4385 6.43133 10.8801 6.43133ZM3.60791 12.7058C3.60791 13.0509 3.89026 13.3333 4.23536 13.3333H11.7648C12.1099 13.3333 12.3922 13.0509 12.3922 12.7058C12.3922 12.3607 12.1099 12.0784 11.7648 12.0784H4.23536C3.89026 12.0784 3.60791 12.3607 3.60791 12.7058Z"
      fill="#DADEE6"
    />
  </svg>
);

export const NonVegFoodIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_10028_163254)">
        <path
          d="M19.1457 6.55734C18.8335 5.1637 18.1316 3.88752 17.1217 2.87764C16.1118 1.86776 14.8356 1.16579 13.442 0.853594C12.4539 0.634844 11.5076 0.634844 10.6295 0.852969C7.06761 1.73734 4.58824 6.09547 4.73386 11.2148C4.74512 11.6164 4.81438 12.0143 4.93949 12.3961L3.90699 13.433C3.48999 13.2245 3.01784 13.1528 2.55776 13.2282C2.09768 13.3036 1.67311 13.5223 1.34449 13.853C0.480736 14.7167 0.466986 16.108 1.31324 16.9542C1.62574 17.2667 2.02136 17.4723 2.44761 17.5511C2.52698 17.981 2.73514 18.3766 3.04449 18.6855C3.24449 18.885 3.48197 19.043 3.74326 19.1503C4.00455 19.2577 4.2845 19.3123 4.56699 19.3111C4.86051 19.3109 5.1511 19.2527 5.42212 19.14C5.69314 19.0273 5.93925 18.8622 6.14636 18.6542C6.47732 18.3258 6.69611 17.9012 6.77153 17.441C6.84695 16.9809 6.77515 16.5087 6.56636 16.0917L7.60324 15.0592C7.98502 15.1843 8.38289 15.2536 8.78449 15.2648C8.92761 15.2692 9.06949 15.2711 9.21136 15.2711C14.1451 15.2711 18.2876 12.8317 19.1476 9.36984C19.3651 8.49172 19.3651 7.54547 19.1457 6.55734ZM5.44511 15.6211C5.34371 15.7223 5.28468 15.8583 5.28004 16.0015C5.27539 16.1446 5.32548 16.2842 5.42011 16.3917C5.78761 16.8086 5.75699 17.453 5.35074 17.8598C4.92511 18.2848 4.24824 18.2986 3.84011 17.8911C3.73307 17.7839 3.65081 17.6545 3.59909 17.5121C3.54737 17.3697 3.52745 17.2176 3.54074 17.0667C3.54747 16.9853 3.53637 16.9033 3.50821 16.8266C3.48005 16.7499 3.43551 16.6802 3.37769 16.6224C3.31987 16.5647 3.25015 16.5202 3.17339 16.4921C3.09664 16.464 3.01468 16.453 2.93324 16.4598C2.78233 16.4727 2.63043 16.4526 2.48808 16.4009C2.34572 16.3492 2.21632 16.2672 2.10886 16.1605C1.70136 15.7523 1.71511 15.0748 2.14011 14.6498C2.54699 14.2442 3.19136 14.2136 3.60824 14.5805C3.71577 14.6751 3.85533 14.7252 3.9985 14.7205C4.14167 14.7159 4.27768 14.6569 4.37886 14.5555L5.46824 13.4617C5.75736 13.8808 6.12036 14.2438 6.53949 14.533L5.44511 15.6211ZM18.0551 9.09922C17.4051 11.7167 14.0245 14.288 8.81574 14.1417C8.03835 14.1191 7.29902 13.8002 6.7491 13.2502C6.19917 12.7003 5.88025 11.961 5.85761 11.1836C5.71011 5.97672 8.28261 2.59484 10.9001 1.94422C11.6076 1.76797 12.3807 1.77109 13.1982 1.95172C14.3831 2.21714 15.468 2.81396 16.3265 3.67259C17.185 4.53121 17.7817 5.61623 18.047 6.80109C18.2289 7.61734 18.2314 8.39047 18.0551 9.09922Z"
          fill="#7A7C89"
        />
      </g>
      <defs>
        <clipPath id="clip0_10028_163254">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const AlcoholIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.77678 0.101072C6.69154 0.156461 6.59564 0.270992 6.56359 0.355603C6.53154 0.440161 6.26582 1.43834 5.97308 2.57373C5.68035 3.70912 5.37327 4.87936 5.2907 5.17426C4.91776 6.50638 4.90423 7.68257 5.24678 8.98354C5.75562 10.916 7.24994 12.5098 8.91922 12.9005C9.12677 12.9491 9.32491 12.9972 9.35948 13.0075C9.40828 13.0219 9.42237 13.4508 9.42237 14.9208V16.8154L7.87517 17.5076C6.1836 18.2643 6.01228 18.3772 5.9041 18.8053C5.83804 19.0668 5.89449 19.4099 6.03819 19.6204C6.09012 19.6965 6.23231 19.813 6.35412 19.8794L6.57571 20H10.0587C12.3973 20 13.5883 19.9813 13.6834 19.9429C13.8569 19.8731 14.0864 19.6475 14.1817 19.4531C14.2657 19.2818 14.2745 18.8889 14.1991 18.6764C14.0818 18.3454 13.9339 18.2589 12.235 17.5281L10.5796 16.816V14.9211C10.5796 13.4499 10.5937 13.0224 10.6425 13.0092C10.6771 12.9999 10.9092 12.9399 11.1583 12.8758C12.6477 12.4926 13.9752 11.1776 14.6016 9.46472C15.1066 8.08375 15.1309 6.6985 14.6778 5.12064C14.5762 4.76676 14.2362 3.53619 13.9222 2.38606C13.4036 0.485952 13.3374 0.281448 13.1975 0.147453L13.0435 0L9.98762 0.000214462C7.08667 0.00037532 6.9239 0.0055228 6.77678 0.101072ZM7.48547 1.24665C7.43319 1.40772 6.47186 5.13308 6.31981 5.76375C6.13324 6.5378 6.10431 6.93957 6.23145 6.99158C6.27523 7.00949 6.49199 7.02413 6.71313 7.02413C7.25422 7.02413 7.65156 6.87764 8.84374 6.23861C10.8728 5.15099 11.8106 4.8703 13.019 4.98895C13.2675 5.01335 13.4739 5.02885 13.4776 5.02338C13.4812 5.01791 13.2719 4.24129 13.0124 3.29759C12.7529 2.35389 12.5173 1.49131 12.489 1.3807L12.4374 1.17962H9.97232C8.04538 1.17962 7.50248 1.19426 7.48547 1.24665ZM12.0136 6.1963C11.9583 6.20981 11.7885 6.24729 11.6363 6.27957C11.2453 6.36247 10.4664 6.71217 9.283 7.33614C7.87502 8.07861 7.1391 8.31453 6.46341 8.24021L6.19563 8.21078L6.2304 8.38155C6.39116 9.17094 6.77899 9.92831 7.35254 10.5727C7.83828 11.1185 8.30843 11.4532 8.89406 11.6702C9.26 11.8058 9.36058 11.8194 10.001 11.8194C10.6414 11.8194 10.742 11.8058 11.1079 11.6702C11.678 11.459 12.1584 11.1209 12.6264 10.6013C13.4809 9.65276 13.8606 8.59796 13.8694 7.14836C13.8717 6.75957 13.8576 6.42445 13.8381 6.40359C13.7078 6.26472 12.3604 6.11164 12.0136 6.1963ZM8.92103 18.3287L7.89142 18.7936L8.98734 18.808C9.59012 18.816 10.5596 18.816 11.1418 18.808L12.2003 18.7936L11.1149 18.3244C10.5179 18.0664 10.0117 17.8572 9.99003 17.8595C9.9684 17.8619 9.48733 18.073 8.92103 18.3287Z"
        fill="#7A7C89"
      />
    </svg>
  );
};
